import { useEffect, useRef, useState } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";
import { FcAddImage } from "react-icons/fc";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Check } from "lucide-react";
import { MdDelete } from "react-icons/md";

const TestEditPropertyDetailElementor = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const { id: paramId } = useParams();
  const propertyid = routerLocation.state?.propertyid ?? paramId;

  const [isLoadingProperty, setIsLoadingProperty] = useState(true);
  const [loadError, setLoadError] = useState("");

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [indiaStates, setIndiaStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);

  useEffect(() => {
    // Load world.json from public folder
    fetch("/world.json")
      .then((res) => res.json())
      .then((data) => {
        const india = data.find((country) => country.name === "India");
        if (india) {
          setIndiaStates(india.states);
        }
      })
      .catch((err) => console.error("Error loading world.json:", err));
  }, []);

  const handleStateChange = (e) => {
    const stateName = e.target.value;
    setSelectedState(stateName);

    if (stateName.toLowerCase() === "goa") {
      const goaCities = [
        "Aldona",
        "Arambol",
        "Baga",
        "Bambolim",
        "Bandora",
        "Benaulim",
        "Calangute",
        "Candolim",
        "Carapur",
        "Cavelossim",
        "Chicalim",
        "Chinchinim",
        "Colovale",
        "Colva",
        "Cortalim",
        "Cuncolim",
        "Curchorem",
        "Curti",
        "Davorlim",
        "Dicholi",
        "Goa Velha",
        "Guirim",
        "Jua",
        "Kankon",
        "Madgaon",
        "Мариса",
        "Morjim",
        "Mormugao",
        "Navelim",
        "North Goa",
        "Palle",
        "Panaji",
        "Pernem",
        "Ponda",
        "Quepem",
        "Queula",
        "Raia",
        "Saligao",
        "Sancoale",
        "Sanguem",
        "Sanquelim",
        "Sanvordem",
        "Serula",
        "Solim",
        "South Goa",
        "Taleigao",
        "Vagator",
        "Valpoy",
        "Varca",
        "Vasco da Gama",
        // Extra villages
        "Anjuna",
        "Arpora",
        "Assagao",
        "Parra",
        "Siolim",
        "Reis Magos",
        "Nerul",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(goaCities.map((city, idx) => ({ id: idx + 1, name: city })));
    } else if (stateName.toLowerCase() === "karnataka") {
      const karnatakaCities = [
        // Extra villages

        // Added cities
        "Afzalpur",
        "Ajjampur",
        "Aland",
        "Alnavar",
        "lark",
        "Alur",
        "Anekal",
        "Ankola",
        "Annigeri",
        "Arkalgud",
        "Arsikere",
        "Athni",
        "Aurad",
        "Badami",
        "Bagalkot",
        "Bagepalli",
        "Bail-Hongal",
        "Ballari",
        "Banavar",
        "Bangarapet",
        "Bannur",
        "Bantval",
        "Basavakalyan",
        "Basavana Bagevadi",
        "Belagavi",
        "Belluru",
        "Beltangadi",
        "Belur",
        "Bengaluru",
        "Bengaluru Rural",
        "Bengaluru Urban",
        "Bhadravati",
        "Bhalki",
        "Bhatkal",
        "Bidar",
        "Bilgi",
        "Birur",
        "Byadgi",
        "Byndoor",
        "Canacona",
        "Challakere",
        "Chamrajnagar",
        "Channagiri",
        "Channapatna",
        "Channarayapatna",
        "Chik Ballapur",
        "Chikkaballapur",
        "Chikkamagaluru",
        "Chiknayakanhalli",
        "Chikodi",
        "Chincholi",
        "Chintamani",
        "Chitapur",
        "Chitradurga",
        "Closepet",
        "Coondapoor",
        "Coorg",
        "Dakshina Kannada",
        "Dandeli",
        "Davanagere",
        "Devanhalli",
        "Dharwad",
        "Dod Ballapur",
        "French Rocks",
        "Gadag",
        "Gadag-Betageri",
        "Gajendragarh",
        "Gangawati",
        "Gangolli",
        "Gokak",
        "Gokarna",
        "Goribidnur",
        "Gorur",
        "Gubbi",
        "Gudibanda",
        "Guledagudda",
        "Gundlupet",
        "Gurmatkal",
        "Hadagalli",
        "Haliyal",
        "Hampi",
        "Hangal",
        "Harihar",
        "Harpanahalli",
        "Hassan",
        "Haveri",
        "Heggadadevankote",
        "Hirekerur",
        "Hiriyur",
        "Holalkere",
        "Hole Narsipur",
        "Homnabad",
        "Honavar",
        "Honnali",
        "Hosanagara",
        "Hosangadi",
        "Hosdurga",
        "Hoskote",
        "Hospet",
        "Hubballi",
        "Hukeri",
        "Hungund",
        "Hunsur",
        "Ilkal",
        "Indi",
        "Jagalur",
        "Jamkhandi",
        "Jevargi",
        "Kabini",
        "Kadur",
        "Kalaburgi",
        "Kalghatgi",
        "Kampli",
        "Kankanhalli",
        "Karkala",
        "Karwar",
        "Kavalur",
        "Kerur",
        "Khanapur",
        "Kodagu",
        "Kodigenahalli",
        "Kodlipet",
        "Kolar",
        "Kollegal",
        "Konanur",
        "Konnur",
        "Koppa",
        "Koppal",
        "Koratagere",
        "Kotturu",
        "Krishnarajpet",
        "Kudachi",
        "Kudligi",
        "Kumsi",
        "Kumta",
        "Kundgol",
        "Kunigal",
        "Kurgunta",
        "Kushalnagar",
        "Kushtagi",
        "Lakshmeshwar",
        "Lingsugur",
        "Londa",
        "Machare",
        "Maddagiri",
        "Maddur",
        "Madikeri",
        "Magadi",
        "Mahalingpur",
        "Malavalli",
        "Malpe",
        "Malur",
        "Mandya",
        "Mangaluru",
        "Manipal",
        "Manvi",
        "Mayakonda",
        "Melukote",
        "Mudbidri",
        "Muddebihal",
        "Mudgal",
        "Mudgere",
        "Mudhol",
        "Mulbagal",
        "Mulgund",
        "Mulki",
        "Mundargi",
        "Mundgod",
        "Munirabad",
        "Murudeshwara",
        "Mysuru",
        "Nagamangala",
        "Nanjangud",
        "Narasimharajapura",
        "Naregal",
        "Nargund",
        "Navalgund",
        "Nelamangala",
        "Nyamti",
        "Pangala",
        "Pavugada",
        "Piriyapatna",
        "Ponnampet",
        "Puttur",
        "Rabkavi",
        "Raichur",
        "Ramanagara",
        "Ranibennur",
        "Raybag",
        "Robertsonpet",
        "Ron",
        "Sadalgi",
        "Sagar",
        "Sakleshpur",
        "Sandur",
        "Sanivarsante",
        "Sankeshwar",
        "Sargur",
        "Saundatti",
        "Savanur",
        "Seram",
        "Shahabad",
        "Shahpur",
        "Shiggaon",
        "Shikarpur",
        "Shimoga",
        "Shirhatti",
        "Shorapur",
        "Shrirangapattana",
        "Siddapur",
        "Sidlaghatta",
        "Sindgi",
        "Sindhnur",
        "Sira",
        "Sirsi",
        "Siruguppa",
        "Someshwar",
        "Somvarpet",
        "Sorab",
        "Sravana Belgola",
        "Sringeri",
        "Srinivaspur",
        "Sulya",
        "Suntikoppa",
        "Talikota",
        "Tarikere",
        "Tekkalakote",
        "Terdal",
        "Tiptur",
        "Tirthahalli",
        "Tirumakudal Narsipur",
        "Tumakuru",
        "Turuvekere",
        "Udupi",
        "Ullal",
        "Uttar Kannada",
        "Vadigenhalli",
        "Vijayapura",
        "Virarajendrapet",
        "Wadi",
        "Yadgir",
        "Yelahanka",
        "Yelandur",
        "Yelbarga",
        "Yellapur",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(
        karnatakaCities.map((city, idx) => ({ id: idx + 1, name: city })),
      );
    } else if (stateName.toLowerCase() === "kerala") {
      const keralaCities = [
        "Adoor",
        "Alappuzha",
        "Alleppey",
        "Aluva",
        "Alwaye",
        "Angamali",
        "Aroor",
        "Arukutti",
        "Attingal",
        "Avanoor",
        "Azhikkal",
        "Beypore",
        "Changanacheri",
        "Chelakara",
        "Chengannur",
        "Cherpulassery",
        "Cherthala",
        "Chetwayi",
        "Chittur",
        "Cochin",
        "Dharmadom",
        "Edakkulam",
        "Elur",
        "Erattupetta",
        "Ernakulam",
        "Ferokh",
        "Guruvayur",
        "Idukki",
        "Iringal",
        "Irinjalakuda",
        "Kadakkavoor",
        "Kalamassery",
        "Kalavoor",
        "Kalpetta",
        "Kanhangad",
        "Kannavam",
        "Kannur",
        "Kasaragod",
        "Kattanam",
        "Kayankulam",
        "Kizhake Chalakudi",
        "Kochi",
        "Kodungallur",
        "Kollam",
        "Kotamangalam",
        "Kottayam",
        "Kovalam",
        "Kozhikode",
        "Kumbalam",
        "Kunnamangalam",
        "Kunnamkulam",
        "Kunnumma",
        "Kutiatodu",
        "Kuttampuzha",
        "Lalam",
        "Mahe",
        "Malappuram",
        "Manjeri",
        "Manjeshwaram",
        "Mannarakkat",
        "Marayur",
        "Mattanur",
        "Mavelikara",
        "Mavoor",
        "Muluppilagadu",
        "Munnar",
        "Muvattupula",
        "Muvattupuzha",
        "Nadapuram",
        "Naduvannur",
        "Nedumangad",
        "Neyyattinkara",
        "Nileshwar",
        "Ottappalam",
        "Palackattumala",
        "Palakkad district",
        "Palghat",
        "Panamaram",
        "Pappinissheri",
        "Paravur Tekkumbhagam",
        "Pariyapuram",
        "Pathanamthitta",
        "Pattanamtitta",
        "Payyanur",
        "Perinthalmanna",
        "Perumbavoor",
        "Perumpavur",
        "Perya",
        "Piravam",
        "Ponnani",
        "Ponmana",
        "Punalur",
        "Punnayur",
        "Ramamangalam",
        "Shertallai",
        "Shoranur",
        "Taliparamba",
        "Thalassery",
        "Thalikulam",
        "Thanniyam",
        "Thekkady",
        "Thiruvananthapuram",
        "Thrissur",
        "Tirur",
        "Tiruvalla",
        "Vaikam",
        "Varkala",
        "Vatakara",
        "Vayalar",
        "Vettur",
        "Wayanad",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(keralaCities.map((city, idx) => ({ id: idx + 1, name: city })));
    } else if (stateName.toLowerCase() === "tamil nadu") {
      const tamilnaduCities = [
        // Tamil Nadu cities
        "Aambur",
        "Ariyalur",
        "Arakkonam",
        "Arani",
        "Attur",
        "Avadi",
        "Batlagundu",
        "Chengalpattu",
        "Chennai",
        "Chidambaram",
        "Coimbatore",
        "Courtallam",
        "Cuddalore",
        "Coonoor",
        "Dharapuram",
        "Dharmapuri",
        "Dindigul",
        "Erode",
        "Gobichettipalayam",
        "Gudalur",
        "Gudiyatham",
        "Hosur",
        "Jayankondam",
        "Kallakurichi",
        "Kanchipuram",
        "Kanyakumari",
        "Karaikudi",
        "Karur",
        "Kodaikanal",
        "Kovilpatti",
        "Krishnagiri",
        "Kumbakonam",
        "Madurai",
        "Manapparai",
        "Mahabalipuram",
        "Mayiladuthurai",
        "Mettupalayam",
        "Namakkal",
        "Nagapattinam",
        "Nagercoil",
        "Ooty",
        "Palani",
        "Pallavaram",
        "Pattukkottai",
        "Perambalur",
        "Pollachi",
        "Poonamallee",
        "Pudukkottai",
        "Rajapalayam",
        "Ramanathapuram",
        "Ranipet",
        "Salem",
        "Sankagiri",
        "Sivaganga",
        "Sivakasi",
        "Tambaram",
        "Tenkasi",
        "Thanjavur",
        "Theni",
        "Thiruvallur",
        "Thiruvarur",
        "Thoothukudi",
        "Tindivanam",
        "Tiruchendur",
        "Tiruchengode",
        "Tiruchirappalli",
        "Tirunelveli",
        "Tirupathur",
        "Tiruppur",
        "Tiruvannamalai",
        "Udagamandalam",
        "Udumalpet",
        "Usilampatti",
        "Vaniyambadi",
        "Vellore",
        "Villupuram",
        "Virudhunagar",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(
        tamilnaduCities.map((city, idx) => ({ id: idx + 1, name: city })),
      );
    } else {
      const stateObj = indiaStates.find((s) => s.name === stateName);
      setCities(stateObj ? stateObj.cities : []);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const MAX_CARDS = 50;

  const [selectedImages, setSelectedImages] = useState(
    Array(MAX_CARDS).fill(null),
  );

  // Category assigned to each banner slide/image (parallel array to selectedImages)
  const [selectedCategories, setSelectedCategories] = useState(
    Array(MAX_CARDS).fill(""),
  );

  const [activeBannerIndex, setActiveBannerIndex] = useState(0);
  const [bannerCategoryError, setBannerCategoryError] = useState("");
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const bannerCarouselRef = useRef(null);

  // Checks whether the slide at `index` is blocking navigation.
  // Only a NEWLY uploaded file (has `.file`) without a category blocks —
  // images that were already loaded from the server (no `.file`, e.g.
  // existing carousel images or converted legacy images) never block, since
  // legacy images predate the category concept and shouldn't be forced to
  // pick one just to view/save the rest of the form.
  const isBannerSlideBlocked = (index) => {
    return !!selectedImages[index]?.file && !selectedCategories[index];
  };

  const CustomLeftArrowBannerCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowBannerCarousel = ({ onClick }) => {
    const handleNextClick = () => {
      // Block moving to the next slide until the current slide's image has a category
      // if (isBannerSlideBlocked(activeBannerIndex)) {
      //   setBannerCategoryError(
      //     "Please select a category for this image before moving to the next slide.",
      //   );
      //   return;
      // }
      setBannerCategoryError("");
      onClick();
    };

    return (
      <button
        onClick={handleNextClick}
        className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  // Plain arrows (no category validation) — used by carousels other than the
  // main banner (e.g. the per-bedroom image carousels below), so they don't
  // accidentally inherit the banner's category-gate logic.
  const CustomLeftArrowPlain = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowPlain = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  // Guards against the corrective goToSlide (below) re-triggering this same
  // handler and causing an oscillation/"stuck" loop.
  const isCorrectingBannerSlideRef = useRef(false);

  // Safety net for navigation that bypasses the arrow buttons (swipe, keyboard, dots):
  // if the previous slide had an image without a category, snap back to it —
  // but ONLY when moving forward. Moving backward must always be allowed,
  // otherwise a later incomplete slide permanently blocks the user from ever
  // navigating back to fix it.
  const handleBannerAfterChange = (previousSlide, { currentSlide }) => {
    if (isCorrectingBannerSlideRef.current) {
      isCorrectingBannerSlideRef.current = false;
      setActiveBannerIndex(currentSlide);
      return;
    }

    const movingForward = currentSlide > previousSlide;

    // if (movingForward && isBannerSlideBlocked(previousSlide)) {
    //   setBannerCategoryError(
    //     "Please select a category for this image before moving to the next slide.",
    //   );
    //   isCorrectingBannerSlideRef.current = true;
    //   if (bannerCarouselRef.current) {
    //     bannerCarouselRef.current.goToSlide(previousSlide);
    //   }
    //   setActiveBannerIndex(previousSlide);
    //   return;
    // }
    setBannerCategoryError("");
    setActiveBannerIndex(currentSlide);
  };

  const handleImageUpload = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...selectedImages];
      // position is index + 1 -> row in `allPropertyImages`
      updatedImages[index] = { url: imageurl, file };
      setSelectedImages(updatedImages);
    }
  };

  const handleBannerImageDelete = async (index) => {
    const img = selectedImages[index];

    // Clear locally right away for a snappy UI.
    setSelectedImages((prev) => {
      const u = [...prev];
      u[index] = null;
      return u;
    });
    setSelectedCategories((prev) => {
      const u = [...prev];
      u[index] = "";
      return u;
    });
    setBannerCategoryError("");

    // If this was already a persisted image (loaded from the server, no
    // pending `.file`), delete it from the DB + Cloudflare right now instead
    // of waiting for the next full-form Save. Freshly-picked-but-not-yet-saved
    // uploads (has `.file`) were never written anywhere, so nothing to call.
    if (img?.url && !img?.file && propertyid) {
      try {
        const res = await fetch(
          `https://demo.zorbastays.com/web-backend/property/${propertyid}/image`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ imageurl: img.url }),
          },
        );
        const data = await res.json();
        if (!res.ok || !data.success) {
          throw new Error(data.error || "Failed to delete image");
        }
      } catch (err) {
        console.error("Error deleting image:", err);
        setSubmitError(
          "That image was removed here but couldn't be deleted on the server. It may reappear if you don't save.",
        );
      }
    }
  };

  // Deletes a Tailored Experience grid image (imagegrid1-4 on propertyImages).
  // Same idea as handleBannerImageDelete: clear locally right away, and if
  // this was already a persisted image (a real saved URL, not a fresh
  // not-yet-saved file), delete it from Cloudflare + null the column now
  // instead of waiting for the next form Save — Save alone never sends this
  // field once it's cleared, so without this call the old value would just
  // sit in the DB untouched.
  const handleTailoredexpimageDelete = async (index) => {
    const exp = tailoredExpData[index];
    const wasPersisted = !!exp?.img && !exp?.file;

    setTailoredExpData((prev) => {
      const u = [...prev];
      u[index] = { ...u[index], img: null, file: null };
      return u;
    });

    if (wasPersisted && propertyid) {
      try {
        const res = await fetch(
          `https://demo.zorbastays.com/web-backend/property/${propertyid}/image`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              fieldName: `imagegrid${index + 1}`,
              table: "propertyImages",
            }),
          },
        );
        const data = await res.json();
        if (!res.ok || !data.success) {
          throw new Error(data.error || "Failed to delete image");
        }
      } catch (err) {
        console.error("Error deleting tailored experience image:", err);
        setSubmitError(
          "That image was removed here but couldn't be deleted on the server. It may reappear if you don't save.",
        );
      }
    }
  };

  const handleBannerCategoryChange = (index, categoryValue) => {
    setSelectedCategories((prev) => {
      const u = [...prev];
      u[index] = categoryValue;
      return u;
    });
    if (categoryValue) {
      setBannerCategoryError("");
    }
  };

  // Builds the ordered category list, with Bedroom/Bathroom expanded dynamically
  // based on the "No. of Rooms" (bookingRooms/maxbed) and "Max Bathroom" (maxbath) inputs.
  const getBannerCategoryOptions = () => {
    const bedroomCount = parseInt(bookingRooms) || 0;
    const bathroomCount = parseInt(maxbath) || 0;

    const bedroomOptions =
      bedroomCount > 0
        ? Array.from({ length: bedroomCount }, (_, i) => `Bedroom ${i + 1}`)
        : ["Bedroom"];

    const bathroomOptions =
      bathroomCount > 0
        ? Array.from({ length: bathroomCount }, (_, i) => `Bathroom ${i + 1}`)
        : ["Bathroom"];

    return [
      "Living Room",
      "Dining Area",
      ...bedroomOptions,
      ...bathroomOptions,
      "Pool",
      "Courtyard",
      "Games & Activity Area",
      "Exterior",
      "Jacuzzi",
      "Theatre Room",
      "Gym",
      "Garden",
      "Kitchen",
      "Additional Photos",
    ];
  };

  // Groups every selected banner image by its assigned category, for the "View All" gallery.
  // Categories with no images are omitted.
  const getGroupedBannerGallery = () => {
    const grouped = {};
    getBannerCategoryOptions().forEach((cat) => {
      grouped[cat] = [];
    });
    selectedImages.forEach((img, index) => {
      const cat = selectedCategories[index];
      if (img && cat) {
        if (!grouped[cat]) grouped[cat] = [];
        grouped[cat].push({ ...img, index });
      }
    });
    return Object.entries(grouped).filter(([, imgs]) => imgs.length > 0);
  };

  // Pulls the images assigned to a given bedroom directly from the banner's
  // selectedImages/selectedCategories (category === "Bedroom {roomIndex + 1}").
  // This keeps the Bedroom Carousel section below in sync with the banner —
  // there is no separate upload step here anymore.
  const getBedroomImages = (roomIndex) => {
    const categoryLabel = `Bedroom ${roomIndex + 1}`;
    const images = [];
    selectedImages.forEach((img, idx) => {
      if (img && selectedCategories[idx] === categoryLabel) {
        images.push({ ...img, bannerIndex: idx });
      }
    });
    return images;
  };

  const TailoredExpCarousel = [
    {
      img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/77613/villa-barbados-caribbean-luxury-the-great-house-boat_FullL.jpg?v=302558110212",
      title: "For Adventure Seekers",
      content:
        "Experience the thrill of Goa with our adventure package! Enjoy cozy stays, a hearty breakfast, and activities like water sports, trekking, and more.",
    },
    {
      img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/66699/villa-barbados-caribbean-luxury-the-great-house-ext-9_FullL.jpg?v=302558110212",
      title: "For Leisure Lovers",
      content:
        "Unwind with our leisure package in Goa. Relax in serene stays, savor a delicious breakfast, and enjoy peaceful beaches, spa sessions, and local attractions.",
    },
  ];

  const responsive_TailoredExpCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_OuterCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 3,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 3,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_BannerCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const [showDots, setShowDots] = useState(false);

  useEffect(() => {
    const updateDotsVisibility = () => {
      setShowDots(window.innerWidth < 768);
    };

    updateDotsVisibility();
    window.addEventListener("resize", updateDotsVisibility);
    return () => window.removeEventListener("resize", updateDotsVisibility);
  }, []);

  const responsive_ImageCarouselOne = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const CustomLeftArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-44 transform -translate-y-1/2 shadow-custom bg-white bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-44 transform -translate-y-1/2 shadow-custom bg-white bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const carouselRef = useRef(null);

  const handlePrevSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.previous();
    }
  };

  const handleNextSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const [, setIsOpen_dropdownExp] = useState(false);
  const dropdownRef_dropdownExp = useRef(null);

  useEffect(() => {
    const handleClickOutside_dropdownExp = (event) => {
      if (
        dropdownRef_dropdownExp.current &&
        !dropdownRef_dropdownExp.current.contains(event.target)
      ) {
        setIsOpen_dropdownExp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside_dropdownExp);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
  }, []);
  const [tailoredExpData, setTailoredExpData] = useState([
    { img: null, title: "", content: "" },
    { img: null, title: "", content: "" },
    { img: null, title: "", content: "" },
    { img: null, title: "", content: "" },
  ]);
  const MAX_CARDS_Exp = tailoredExpData.length;

  // Booking Widget States
  const [bookingPrice, setBookingPrice] = useState("");
  const [bookingPriceDetails, setBookingPriceDetails] = useState(
    "(for 10 rooms) Per Night + Taxes",
  );
  const [bookingcheckinDate, setBookingcheckinDate] = useState("");
  const [bookingcheckintime, setBookingcheckintime] = useState("");
  const [bookingcheckoutDate, setBookingcheckoutDate] = useState("");
  const [bookingcheckouttime, setBookingcheckouttime] = useState("");
  const [bookingAdults, setBookingAdults] = useState("2");
  const [bookingChildren, setBookingChildren] = useState("0");
  const [bookingRooms, setBookingRooms] = useState("3");
  const [bookingTotal, setBookingTotal] = useState("");

  const [propertyname, setpropertyname] = useState("");
  const [description, setDescription] = useState("");
  const [heading, setHeading] = useState("");
  const [content, setContent] = useState("");
  const [catchyQuote, setCatchyQuote] = useState("");
  const [maptitle, setmaptitle] = useState("");
  const [mapcontent, setmapcontent] = useState("");
  const [tailoredExperience, setTailoredExperience] = useState("");
  const [tailoredExperienceContent, setTailoredExperienceContent] =
    useState("");

  const [maplang, setmaplang] = useState("");
  const [maplong, setmaplong] = useState("");

  // Additional required data (not shown on website)
  const [propertycode, setpropertycode] = useState("");
  const [propertyowner, setpropertyowner] = useState("");
  const [airid, setairid] = useState("");
  const [instagramreellink, setinstagramreellink] = useState("");
  const [propertyBrochure, setPropertyBrochure] = useState("");
  const [defaultprice, setdefaultprice] = useState("");
  const [deposit, setDeposit] = useState("");
  const [maxbath, setmaxbath] = useState("");
  const [maplink, setMaplink] = useState("");
  const [youtubelink, setYoutubelink] = useState("");
  const [seasonType, setSeasonType] = useState("");
  const [propertytype, setpropertytype] = useState("Villa");
  const [location, setLocation] = useState("");
  const [rating, setRating] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const [amenitiesList, setAmenitiesList] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]); // stores ids: [1, 4, 5]

  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen_amenities, setIsOpen_amenities] = useState(false);

  useEffect(() => {
    fetch("https://demo.zorbastays.com/web-backend/getAmenities")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setAmenitiesList(data.data);
      })
      .catch((err) => console.error("Failed to load amenities", err));
  }, []);

  // Toggle stores/removes the numeric id
  const toggleAmenity = (id) => {
    setSelectedAmenities((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id],
    );
  };

  const filteredAmenities = amenitiesList.filter((amenity) =>
    amenity.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const containerRef_amenities = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef_amenities.current &&
        !containerRef_amenities.current.contains(event.target)
      ) {
        setIsOpen_amenities(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // ─── Fetch existing property + autofill the form ───
  useEffect(() => {
    if (!propertyid) {
      setIsLoadingProperty(false);
      setLoadError(
        "No property selected to edit — missing propertyid (check the navigate() call that opened this page).",
      );
      return;
    }

    const loadProperty = async () => {
      setIsLoadingProperty(true);
      setLoadError("");
      try {
        const res = await fetch(
          `https://demo.zorbastays.com/web-backend/admin/properties/${propertyid}`,
        );
        if (!res.ok) throw new Error("Failed to load property");
        const p = await res.json();

        // ── Simple fields ──
        setpropertyname(p.propertyname || "");
        setDescription(p.description || "");
        setHeading(p.heading || "");
        setContent(p.content || "");
        setCatchyQuote(p.catchquote || "");
        setmaptitle(p.maptitle || "");
        setmapcontent(p.mapcontent || "");
        setmaplang(p.maplang ?? "");
        setmaplong(p.maplong ?? "");
        setpropertycode(p.propertycode || "");
        setpropertyowner(p.propertyowner || "");
        setairid(p.airid || "");
        setinstagramreellink(p.instagramreellink || "");
        setPropertyBrochure(p.propertyBrochure || "");
        setBookingPrice(p.currentprice ?? "");
        setdefaultprice(p.defaultprice ?? "");
        setDeposit(p.deposit ?? "");
        setBookingAdults(String(p.maxadult ?? "2"));
        setBookingChildren(String(p.maxchild ?? "0"));
        setBookingRooms(String(p.maxbed ?? "3"));
        setmaxbath(String(p.maxbath ?? ""));
        setMaplink(p.maplink || "");
        setYoutubelink(p.youtubelink || "");
        setSeasonType(p.seasonType || "");
        setpropertytype(p.propertytype || "Villa");
        setSelectedState(p.destination || "");
        setLocation(p.location || "");
        setRating(p.rating ?? "");

        // ── Amenities (stored as comma-joined ids string) ──
        if (p.addons) {
          setSelectedAmenities(
            String(p.addons)
              .split(",")
              .map((v) => parseInt(v, 10))
              .filter((v) => !isNaN(v)),
          );
        }

        // ── Tailored experience ──
        setTailoredExperience(p.expnamemain || "");
        setTailoredExperienceContent(p.expcontentmain || "");
        setTailoredExpData([
          { img: p.imagegrid1 || null, title: "", content: "" },
          { img: p.imagegrid2 || null, title: "", content: "" },
          { img: p.imagegrid3 || null, title: "", content: "" },
          { img: p.imagegrid4 || null, title: "", content: "" },
        ]);

        // ── Merged top carousel ──
        // Every property's images now live in allPropertyImages, so this is
        // the same simple fill-in for every property, old or new.
        const images = Array.isArray(p.images) ? p.images : [];
        const filledImages = Array(MAX_CARDS).fill(null);
        const filledCategories = Array(MAX_CARDS).fill("");

        images.forEach((img, i) => {
          if (i >= MAX_CARDS) return; // guard against more images than slots
          filledImages[i] = { url: img.imageurl, file: null };
          filledCategories[i] = img.category || "";
        });

        setSelectedImages(filledImages);
        setSelectedCategories(filledCategories);
      } catch (err) {
        console.error("Error loading property:", err);
        setLoadError(err.message || "Failed to load property");
      } finally {
        setIsLoadingProperty(false);
      }
    };

    loadProperty();
  }, [propertyid]);

  const handleSubmit = async () => {
    setSubmitError("");

    if (
      !propertyname ||
      !propertycode ||
      !propertytype ||
      !selectedState ||
      !location
    ) {
      setSubmitError("Please fill all required (*) fields before saving.");
      return;
    }

    const uncategorizedBannerIndex = selectedImages.findIndex(
      (img, index) => img?.file && !selectedCategories[index],
    );
    // if (uncategorizedBannerIndex !== -1) {
    //   setSubmitError(
    //     `Please select a category for banner slide ${uncategorizedBannerIndex + 1} before saving.`,
    //   );
    //   return;
    // }

    setIsSubmitting(true);
    try {
      const formData = new FormData();

      // ── Simple text fields -> `properties` table ──
      formData.append("propertyname", propertyname);
      formData.append("description", description);
      formData.append("heading", heading);
      formData.append("content", content);
      formData.append("catchquote", catchyQuote);
      formData.append("maplang", maplang);
      formData.append("maplong", maplong);
      formData.append("propertycode", propertycode);
      formData.append("propertyowner", propertyowner);
      formData.append("airid", airid);
      formData.append("instagramreellink", instagramreellink);
      formData.append("propertyBrochure", propertyBrochure);
      formData.append("currentprice", bookingPrice);
      formData.append("defaultprice", defaultprice);
      formData.append("deposit", deposit);
      formData.append("maxadult", bookingAdults);
      formData.append("maxchild", bookingChildren);
      formData.append("maxbed", bookingRooms);
      formData.append("maxbath", maxbath);
      formData.append("maplink", maplink);
      formData.append("youtubelink", youtubelink);
      formData.append("seasonType", seasonType);
      formData.append("propertytype", propertytype);
      formData.append("destination", selectedState);
      formData.append("location", location);
formData.append("rating", rating);
      // ── Map / propertyImages text fields ──
      formData.append("maptitle", maptitle);
      formData.append("mapcontent", mapcontent);

      // ── Amenities (ids) ──
      formData.append("amenities", JSON.stringify(selectedAmenities));

      // ── Tailored experience ──
      formData.append("expnamemain", tailoredExperience);
      formData.append("expcontentmain", tailoredExperienceContent);

      // ── Merged top carousel ──
      // allPropertyImages is the source of truth for every property now.
      // Slides with a fresh upload go through banner_<position>(+_category);
      // slides that are unchanged (already-saved image, no new file) are
      // passed back as `existingImages` JSON so the backend keeps them
      // instead of deleting them when it rebuilds the table.
      const existingImages = [];
      selectedImages.forEach((img, index) => {
        if (!img) return;
        const position = index + 1;
        if (img.file) {
          formData.append(`banner_${position}`, img.file);
          formData.append(
            `banner_${position}_category`,
            selectedCategories[index] || "",
          );
        } else {
          existingImages.push({
            imageurl: img.url,
            position,
            category: selectedCategories[index] || "",
          });
        }
      });
      formData.append("existingImages", JSON.stringify(existingImages));

      // ── Tailored experience images -> `experiences` (imagegrid1..4) ──
      // New uploads go as files; unchanged ones are passed back as plain URL
      // strings; cleared ones are sent as an explicit empty string so the
      // backend can tell "untouched" apart from "deleted" and null the
      // column on save too (belt-and-suspenders alongside the instant
      // delete call in handleTailoredexpimageDelete).
      tailoredExpData.forEach((exp, index) => {
        if (exp?.file) {
          formData.append(`expimage${index + 1}`, exp.file);
        } else {
          formData.append(`imagegrid${index + 1}`, exp?.img || "");
        }
      });

      const response = await fetch(
        `https://demo.zorbastays.com/web-backend/${propertyid}`,
        {
          method: "PUT",
          body: formData,
        },
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || "Failed to update property");
      }

      setIsSubmitting(false);
      navigate("/Properties");
    } catch (err) {
      console.error("Error saving property:", err);
      setSubmitError(err.message || "Something went wrong while saving.");
      setIsSubmitting(false);
    }
  };

  if (isLoadingProperty) {
    return (
      <div className="flex items-center justify-center w-full h-screen text-gray-500">
        Loading property…
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-screen text-red-600 gap-3">
        <p>{loadError}</p>
        <button
          onClick={() => navigate("/Properties")}
          className="px-4 py-2 bg-gray-800 text-white rounded-lg text-sm"
        >
          Back to Properties
        </button>
      </div>
    );
  }

  return (
    <div
      className={`flex bg-[#F8F9FA] transition-all duration-500 ${
        isMobile ? "ml-0" : isSidebarOpen ? "w-[82vw]" : "w-[95vw]"
      }`}
    >
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Add New Property
            </p>
          </div>
        </div>

        {/* Data not to be shown in website */}
        <div className="mt-10">
          <p className="text-lg text-center mb-6">
            Required Data <i>(not to be displayed on the website)</i>
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5">
            <div className="flex flex-col w-full">
              {/* goes to table properties as propertycode */}
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Property Code <sub className="text-red-500 text-base">*</sub>
              </label>
              <input
                placeholder="Enter property code"
                name="propertycode"
                required
                value={propertycode}
                onChange={(e) => setpropertycode(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as propertyowner */}
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Property's Owner name
              </label>
              <input
                placeholder="Enter Owner's name"
                name="propertyowner"
                value={propertyowner}
                onChange={(e) => setpropertyowner(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>
            <div className="flex flex-col w-full">
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Property ID
              </label>
              <input
                placeholder="Enter Airbnb ID"
                name="airid"
                value={airid}
                onChange={(e) => setairid(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>
            <div className="flex flex-col w-full">
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Instagram Reel Link
              </label>
              <input
                placeholder="Enter Instagram Reel Link"
                name="instagramreellink"
                value={instagramreellink}
                onChange={(e) => setinstagramreellink(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>
            <div className="flex flex-col w-full">
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Property Brochure
              </label>
              <input
                placeholder="Enter Drive Link"
                name="propertyBrochure"
                value={propertyBrochure}
                onChange={(e) => setPropertyBrochure(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as defaultprice */}
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Default Price
              </label>
              <input
                placeholder="Enter default price"
                name="defaultprice"
                value={defaultprice}
                onChange={(e) => setdefaultprice(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as deposit */}

              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Security Deposit
              </label>
              <input
                placeholder="Enter security deposit"
                name="deposit"
                value={deposit}
                onChange={(e) => setDeposit(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as maxadult
                  Synced with "Guests" (Adults) in the Booking Widget below —
                  both read/write the same `bookingAdults` state. */}

              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Max Adults
              </label>
              <input
                type="number"
                placeholder="Enter max adults"
                name="maxadult"
                value={bookingAdults}
                onChange={(e) => setBookingAdults(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as maxchild
                  Synced with "Guests" (Children) in the Booking Widget below —
                  both read/write the same `bookingChildren` state. */}

              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Max Children
              </label>
              <input
                type="number"
                placeholder="Enter max children"
                name="maxchild"
                value={bookingChildren}
                onChange={(e) => setBookingChildren(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as maxbed
                  Synced with "No. of Rooms" in the Booking Widget below —
                  both read/write the same `bookingRooms` state, so changing
                  either one updates the other automatically. */}

              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Max Bedroom
              </label>
              <input
                type="number"
                placeholder="Enter max bedroom"
                name="maxbed"
                value={bookingRooms}
                onChange={(e) => setBookingRooms(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as maxbath */}

              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Max Bathroom
              </label>
              <input
                placeholder="Enter max bathroom"
                name="maxbath"
                value={maxbath}
                onChange={(e) => setmaxbath(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as maplink */}
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Map Location
              </label>
              <input
                placeholder="Enter map location"
                name="maplink"
                value={maplink}
                onChange={(e) => setMaplink(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as youtubelink */}
              <label
                for="input"
                className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
              >
                Youtube Link
              </label>
              <input
                placeholder="Enter youtube link"
                name="youtubelink"
                value={youtubelink}
                onChange={(e) => setYoutubelink(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              />
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as seasonType */}
              <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                Season Type
              </label>

              <select
                name="seasonType"
                value={seasonType}
                onChange={(e) => setSeasonType(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              >
                <option value="">Select season type</option>
                <option value="Summer">Summer</option>
                <option value="Winter">Winter</option>
                <option value="Monsoon">Monsoon</option>
              </select>
            </div>

            <div className="flex flex-col w-full">
              {/* goes to table properties as propertytype */}
              <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                Property Type<sub className="text-red-500 text-base">*</sub>
              </label>

              <select
                name="propertytype"
                required
                value={propertytype}
                onChange={(e) => setpropertytype(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              >
                <option value="Villa">Villa</option>
              </select>
            </div>

            {/* Destination (State) */}
            <div className="flex flex-col w-full">
              <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                Destination<sub className="text-red-500 text-base">*</sub>
              </label>
              <select
                name="destination"
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                value={selectedState}
                onChange={handleStateChange}
                required
              >
                <option value="">Select your destination</option>
                {indiaStates.map((state) => (
                  <option key={state.id} value={state.name}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Location (City) */}
            <div className="flex flex-col w-full">
              <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                Select Location <sub className="text-red-500 text-base">*</sub>
              </label>
              <select
                name="location"
                required
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              >
                <option value="">Select your location</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col w-full">
              <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                Property Rating
              </label>

              <select
                name="rating"
                required
                value={rating}
                onChange={(e) => setRating(e.target.value)}
                className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
              >
                <option value="0">Enter Rating</option>
                <option value="5">5</option>
                <option value="4">4</option>
                <option value="3">3</option>
                <option value="2">2</option>
                <option value="1">1</option>
                <option value="0">0</option>
              </select>
            </div>
          </div>
        </div>

        <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-10 md:my-16 justify-center">
          <div className="h-[1px] w-full bg-gray-300" />
          <img
            src="../assets/zorba_logo.webp"
            alt="Img"
            className="h-4 w-auto"
          />
          <div className="h-[1px] w-full bg-gray-300" />
        </div>

        <div className="my-10">
          <div className="">
            <div className="flex flex-col items-center justify-center w-full max-w-3xl mx-auto text-center mt-8">
              <div className="w-full">
                {/* goes to table "properties" as "propertyname" */}
                <input
                  type="text"
                  name="propertyname"
                  required
                  maxLength={50}
                  value={propertyname}
                  onChange={(e) => setpropertyname(e.target.value)}
                  className="w-full text-center text-2xl sm:text-3xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Enter Property Name"
                />
                <p className="text-xs mt-1 text-center">
                  {propertyname.length.toString().padStart(2, "0")}/50
                </p>
                {/* goes to table "properties" as "description" */}
                <div className="my-4">
                  <textarea
                    rows="2"
                    name="description"
                    maxLength={250}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="w-full text-center text-gray-700 text-lg border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Enter Property Description..."
                  />
                  <p className="text-xs text-center">
                    {description.length.toString().padStart(2, "0")}/250
                  </p>
                </div>
              </div>
            </div>

            {/* Banner carousel */}
            <div className="mt-5 -mx-3 relative">
              {/* Images are stored in the `allPropertyImages` table with:
    propertyid, imageurl, and position (1, 2, 3, ...)
*/}

              <Carousel
                ref={bannerCarouselRef}
                responsive={responsive_BannerCarousel}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite={false}
                keyBoardControl
                showDots={false}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
                afterChange={handleBannerAfterChange}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[58vh] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {selectedImages[index] ? (
                        <>
                          <img
                            src={selectedImages[index]?.url}
                            alt="Img"
                            className="w-full h-full object-cover"
                          />

                          <div
                            onClick={() => handleBannerImageDelete(index)}
                            className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                          >
                            <MdDelete size={18} />
                          </div>

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/webp"
                              onChange={(e) => handleImageUpload(e, index)}
                              className="hidden"
                            />
                          </label>

                          {/* Per-slide category dropdown (mandatory once this slide has an image) */}
                          <div className="absolute bottom-2 right-24 z-10 flex flex-col items-end">
                            <select
                              name={`bannerCategory_${index}`}
                              value={selectedCategories[index] || ""}
                              onChange={(e) =>
                                handleBannerCategoryChange(
                                  index,
                                  e.target.value,
                                )
                              }
                              className={`text-xs font-medium rounded-md px-2 py-1.5 max-w-[150px] focus:outline-none focus:ring-0 shadow-sm ${
                                selectedCategories[index]
                                  ? "bg-white/90 border border-gray-300 text-gray-800"
                                  : "bg-red-50/95 border border-red-500 text-red-700"
                              }`}
                            >
                              <option value="">Select category*</option>
                              {getBannerCategoryOptions().map((cat) => (
                                <option key={cat} value={cat}>
                                  {cat}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/webp"
                            onChange={(e) => handleImageUpload(e, index)}
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute top-1 left-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>

              {/* View All button, pinned to the banner's bottom-right corner (stays put while slides change) */}
              <button
                type="button"
                onClick={() => setShowGalleryModal(true)}
                className="absolute z-20 bottom-2.5 right-6 px-4 py-[7.5px] bg-green-800 hover:bg-green-700 rounded-md text-white text-xs font-medium shadow-sm transition-colors"
              >
                View All
              </button>

              {bannerCategoryError && (
                <p className="absolute z-20 bottom-14 right-3 bg-red-600 text-white text-xs px-3 py-1.5 rounded shadow-sm max-w-xs text-right">
                  {bannerCategoryError}
                </p>
              )}
            </div>
          </div>

          {/* View All Gallery Modal */}
          {showGalleryModal && (
            <div
              className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
              onClick={() => setShowGalleryModal(false)}
            >
              <div
                className="bg-white rounded-xl w-full max-w-5xl max-h-[85vh] overflow-y-auto pt-0 p-6 relative"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  onClick={() => setShowGalleryModal(false)}
                  className="sticky top-3 ml-auto block z-50 text-gray-500 hover:text-black text-xl font-semibold px-2"
                >
                  ✕
                </button>

                {getGroupedBannerGallery().length === 0 ? (
                  <p className="text-gray-500 text-sm">
                    No images have been assigned a category yet.
                  </p>
                ) : (
                  getGroupedBannerGallery().map(([category, images]) => (
                    <div key={category} className="mb-8">
                      <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b border-gray-100 pb-2">
                        {category}{" "}
                        <span className="text-sm font-normal text-gray-400">
                          ({images.length})
                        </span>
                      </h3>
                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                        {images.map((img) => (
                          <div
                            key={img.index}
                            className="aspect-square rounded-lg overflow-hidden border border-gray-200"
                          >
                            <img
                              src={img.url}
                              alt={category}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10">
            <div className="lg:col-span-2">
              <div className="grid grid-cols-1">
                <div className="order-1 lg:order-2 mt-5 lg:mt-10 text-left">
                  {/* goes to table "properties" as "heading" */}
                  <input
                    type="text"
                    maxLength={100}
                    value={heading}
                    onChange={(e) => setHeading(e.target.value)}
                    className="fontPD flex w-full text-left text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    style={{
                      letterSpacing: "1px",
                      wordSpacing: "2px",
                      lineHeight: 1.3,
                    }}
                    placeholder="Heading"
                  />
                  <p className="text-xs text-left block mt-1">
                    {heading.length.toString().padStart(2, "0")}/100
                  </p>

                  {/* goes to table "properties" as "content" */}
                  <div className="my-5 lg:my-10">
                    <textarea
                      type="text"
                      rows="3"
                      maxLength={400}
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                      className="flex w-full text-left border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      placeholder="Content..."
                    />
                    <span className="text-xs block mt-1">
                      {content.length.toString().padStart(2, "0")}/400
                    </span>
                  </div>
                </div>
                {/* goes to table "properties" as "catchquote" */}

                <div className="mt-5 lg:mt-0 order-3">
                  <input
                    type="text"
                    maxLength={100}
                    value={catchyQuote}
                    onChange={(e) => setCatchyQuote(e.target.value)}
                    className="flex w-full md:text-xl text-left border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Catchy Quote"
                  />
                  <p className="text-xs text-left block mt-1">
                    {catchyQuote.length.toString().padStart(2, "0")}/100
                  </p>

                  <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-5 justify-center">
                    <div className="h-[1px] w-full bg-gray-300" />
                    <img
                      src="../assets/zorba_logo.webp"
                      alt="Img"
                      className="h-4 w-auto"
                    />
                    <div className="h-[1px] w-full bg-gray-300" />
                  </div>
                </div>
              </div>
              {/* Carousel of Amenities Experience */}
              <div className="mt-5 mb-10" ref={containerRef_amenities}>
                <div className="text-center mb-4">
                  <h2 className="text-2xl font-semibold">Amenities</h2>
                  <p className="text-gray-500 mt-1">
                    {selectedAmenities.length} selected
                  </p>
                </div>

                <input
                  type="text"
                  placeholder="Search amenities..."
                  className="w-full mb-4 px-4 py-3 border rounded-lg focus:outline-none focus:ring-0 focus:border-[1.5px] focus:border-black"
                  value={searchTerm}
                  onFocus={() => setIsOpen_amenities(true)}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                {isOpen_amenities && (
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 overflow-y-auto max-h-96">
                    {filteredAmenities.map((amenity, index) => {
                      const isSelected = selectedAmenities.includes(amenity.id);

                      return (
                        <div
                          key={index}
                          onClick={() => toggleAmenity(amenity.id)}
                          className={`relative cursor-pointer rounded-xl border px-3 py-5 transition-all duration-200
                        ${
                          isSelected
                            ? "border-black shadow-md"
                            : "border-gray-200 hover:border-gray-400"
                        }`}
                        >
                          {/* Tick */}
                          {isSelected && (
                            <div className="absolute top-3 right-3 bg-green-800 text-white rounded-full p-1">
                              <Check size={16} />
                            </div>
                          )}

                          {/* Icon */}
                          <img
                            src={amenity.url}
                            alt={amenity.name}
                            className="w-auto h-20 mb-3 object-contain"
                          />

                          {/* Text */}
                          <p className="text-base font-medium">
                            {amenity.name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              {/* Wrapping Carousel for all 5 image categories */}
              {/* Bedroom Carousel — sourced from the banner images assigned to
                  "Bedroom 1", "Bedroom 2", ... "Bedroom N" categories above. */}
              <div className="mt-8 mb-5 border border-gray-200 p-4 rounded-xl shadow-sm bg-gray-50 -mx-3 md:mx-0">
                {/* 
  Bedroom structure:
  - One row per bedroom in `allPropertyBedrooms`
  • propertyid
  • position = roomIndex + 1

  - One row per image in `allPropertyBedroomImages`, sourced from the banner
    images tagged with category "Bedroom {position}"
  • bedroomID (FK -> allPropertyBedrooms.id)
  • imageurl
  • position = imgIndex + 1
  */}
                <Carousel
                  key={`bedroom-outer-carousel-${parseInt(bookingRooms) || 1}`}
                  responsive={responsive_OuterCarousel}
                  autoPlay={false}
                  infinite={true}
                  showDots={true}
                  keyBoardControl={true}
                  arrows={false}
                >
                  {Array.from({ length: parseInt(bookingRooms) || 1 }).map(
                    (_, roomIndex) => {
                      const images = getBedroomImages(roomIndex);
                      return (
                        <div key={roomIndex} className="px-4 pb-8">
                          <h3 className="text-center font-bold text-lg mb-4">
                            Bedroom {roomIndex + 1} Images{" "}
                            <span className="text-sm font-normal text-gray-400">
                              ({images.length})
                            </span>
                          </h3>

                          {images.length === 0 ? (
                            <div className="flex flex-col items-center justify-center w-full aspect-[4/3] max-h-[350px] bg-white border-dashed border-2 border-gray-300 rounded-lg text-center px-4">
                              <p className="text-sm text-gray-400">
                                No images assigned yet. Add images in the banner
                                above and set their category to "Bedroom{" "}
                                {roomIndex + 1}".
                              </p>
                            </div>
                          ) : (
                            <Carousel
                              key={`bedroom-inner-carousel-${roomIndex}-${images.length}`}
                              responsive={responsive_ImageCarouselOne}
                              autoPlay={false}
                              autoPlaySpeed={3000}
                              infinite
                              keyBoardControl
                              showDots={showDots}
                              customLeftArrow={<CustomLeftArrowPlain />}
                              customRightArrow={<CustomRightArrowPlain />}
                            >
                              {images.map((img, imgIndex) => (
                                <div key={img.bannerIndex} className="mx-3">
                                  <div className="flex flex-col items-center justify-between w-full aspect-[4/3] max-h-[350px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                                    <img
                                      src={img.url}
                                      alt={`Bedroom ${roomIndex + 1} - ${imgIndex + 1}`}
                                      className="w-full h-full object-cover"
                                    />
                                    <div
                                      onClick={() =>
                                        handleBannerImageDelete(img.bannerIndex)
                                      }
                                      title="Remove this image from the banner"
                                      className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                                    >
                                      <MdDelete size={18} />
                                    </div>
                                    <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                                      {imgIndex + 1}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </Carousel>
                          )}
                        </div>
                      );
                    },
                  )}
                </Carousel>
              </div>
              {/* Map */}
              <div className="mt-12">
                <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
                  <div>
                    {/* goes to table "propertyImages" as maptitle */}
                    <textarea
                      type="text"
                      maxLength={50}
                      value={maptitle}
                      onChange={(e) => setmaptitle(e.target.value)}
                      rows={2}
                      className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      style={{
                        letterSpacing: "1px",
                        wordSpacing: "2px",
                        lineHeight: 1.3,
                      }}
                      placeholder="Map Title"
                    />
                    <p className="text-xs block">
                      {maptitle.length.toString().padStart(2, "0")}/50
                    </p>
                  </div>

                  <div>
                    {/* goes to table "propertyImages" as mapcontent */}
                    <textarea
                      type="text"
                      maxLength={150}
                      value={mapcontent}
                      onChange={(e) => setmapcontent(e.target.value)}
                      rows={4}
                      className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      placeholder="Map Content..."
                    />
                    <p className="text-xs block">
                      {mapcontent.length.toString().padStart(2, "0")}/150
                    </p>
                  </div>
                </div>
                {/* goes to table "properties" as maplang  */}
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Map Latitude (maplang)
                    </label>
                    <input
                      type="number"
                      step="0.00000001"
                      name="maplang"
                      value={maplang}
                      onChange={(e) => setmaplang(e.target.value)}
                      placeholder="Enter Latitude"
                      className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    />
                  </div>
                  {/* goes to table "properties" as  maplong */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Map Longitude (maplong)
                    </label>
                    <input
                      type="number"
                      step="0.00000001"
                      name="maplong"
                      value={maplong}
                      onChange={(e) => setmaplong(e.target.value)}
                      placeholder="Enter Longitude"
                      className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Side StickyCard */}
            <div className="lg:col-span-1 relative">
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 pb-4 sticky top-10">
                <div className="mb-4">
                  <div className="flex items-center text-4xl font-bold text-[#A23321]">
                    ₹ {/* goes to table properties as currentprice */}
                    <input
                      type="text"
                      value={bookingPrice}
                      placeholder="Enter Current Price"
                      onChange={(e) => setBookingPrice(e.target.value)}
                      className="text-xl w-full bg-transparent border-b border-gray-300 focus:border-black focus:ring-0 px-1 py-0"
                    />
                  </div>
                  {/* <input
                    type="text"
                    value={bookingPriceDetails}
                    onChange={(e) => setBookingPriceDetails(e.target.value)}
                    className="text-base text-gray-400 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 px-1 py-0 mt-1"
                  /> */}
                </div>

                {/* <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="text-sm text-gray-500 font-medium block mb-1">
                      Check-in ▾
                    </label>
                    <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
                      <input
                        type="date"
                        value={bookingcheckinDate}
                        onChange={(e) => setBookingcheckinDate(e.target.value)}
                        className="text-base text-gray-800 font-medium w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0"
                      />
                      <input
                        type="time"
                        value={bookingcheckintime}
                        onChange={(e) => setBookingcheckintime(e.target.value)}
                        className="text-sm text-gray-500 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0 mt-1"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="text-sm text-gray-500 font-medium block mb-1">
                      Check-out ▾
                    </label>
                    <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
                      <input
                        type="date"
                        value={bookingcheckoutDate}
                        onChange={(e) => setBookingcheckoutDate(e.target.value)}
                        className="text-base text-gray-800 font-medium w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0"
                      />
                      <input
                        type="time"
                        value={bookingcheckouttime}
                        onChange={(e) => setBookingcheckouttime(e.target.value)}
                        className="text-sm text-gray-500 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0 mt-1"
                      />
                    </div>
                  </div>
                </div> */}

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <label className="text-sm text-gray-500 font-medium block mb-1">
                      Guests ▾
                    </label>
                    <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
                      <div className="flex items-center border-b border-gray-200 focus-within:border-black">
                        {/* goes to table properties as maxadult */}
                        <input
                          type="number"
                          value={bookingAdults}
                          onChange={(e) => setBookingAdults(e.target.value)}
                          className="text-base text-gray-800 font-medium w-8 bg-transparent border-none focus:ring-0 p-0"
                        />
                        <span className="text-base text-gray-800 font-medium ml-1">
                          Adults,
                        </span>
                      </div>
                      <div className="flex items-center border-b border-gray-200 mt-1 focus-within:border-black">
                        {/* goes to table properties as maxchild */}
                        <input
                          type="number"
                          value={bookingChildren}
                          onChange={(e) => setBookingChildren(e.target.value)}
                          className="text-base text-gray-800 font-medium w-8 bg-transparent border-none focus:ring-0 p-0"
                        />
                        <span className="text-base text-gray-800 font-medium ml-1">
                          Children
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="text-sm text-gray-500 font-medium block mb-1">
                      No. of Rooms ▾
                    </label>
                    <div className="bg-gray-50 border border-gray-200 rounded-md p-3 text-center">
                      <div className="flex items-center justify-center border-b border-gray-200 focus-within:border-black">
                        {/* goes to table properties as maxbed
                            Synced with "Max Bedroom" in the Required Data
                            section above — same `bookingRooms` state. */}
                        <input
                          type="number"
                          value={bookingRooms}
                          onChange={(e) => setBookingRooms(e.target.value)}
                          className="text-base text-gray-800 font-medium w-12 text-right bg-transparent border-none focus:ring-0 p-0"
                        />
                        <span className="text-base text-gray-800 font-medium ml-2">
                          Rooms
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <hr className="border-gray-200 mb-4" />

                <div className="flex justify-between items-center mb-0">
                  <p className="text-2xl font-bold text-gray-800">Total</p>
                  <div className="text-right">
                    <div className="flex items-center justify-end text-2xl font-bold text-[#A23321]">
                      {bookingPrice && !isNaN(bookingPrice) ? (
                        <>
                          ₹{" "}
                          {(parseFloat(bookingPrice) * 1.18).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    <p className="text-sm text-gray-400 mt-1">(Incl. taxes)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Break */}
          <div className="flex gap-3 items-center mx-5 md:mx-[5%] my-8 md:my-14 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>
          {/* Break over  */}

          {/* Tailored Experience */}
          <div className="">
            <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
              <div>
                {/* goes to table "experiences" as "expnamemain" */}
                <input
                  type="text"
                  placeholder="Experience"
                  maxLength={50}
                  value={tailoredExperience}
                  onChange={(e) => setTailoredExperience(e.target.value)}
                  className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  style={{
                    letterSpacing: "1px",
                    wordSpacing: "2px",
                    lineHeight: 1.3,
                  }}
                />
                <p className="text-xs block mt-1">
                  {tailoredExperience.length.toString().padStart(2, "0")}/50
                </p>

                {/* goes to table "experiences" as "expcontentmain" */}
              </div>

              <textarea
                type="text"
                rows={3}
                placeholder="Content..."
                value={tailoredExperienceContent}
                onChange={(e) => setTailoredExperienceContent(e.target.value)}
                maxLength={150}
                className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
              />
              <p className="text-xs block">
                {tailoredExperienceContent.length.toString().padStart(2, "0")}
                /150
              </p>
            </div>

            {/* Carousel of Tailored Experience */}
            <div className="mt-5 -mx-3">
              {/* goes to table "experiences" as "imagegrid1	, imagegrid2, imagegrid3 and imagegrid4" */}
              <Carousel
                ref={carouselRef}
                responsive={responsive_TailoredExpCarousel}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
                customRightArrow={<CustomRightArrowTailoredExpCarousel />}
                beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
              >
                {[...Array(MAX_CARDS_Exp)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="relative w-full h-[350px] bg-white border-2 border-dashed border-gray-400 overflow-hidden">
                      {tailoredExpData[index]?.img ? (
                        <>
                          <img
                            src={tailoredExpData[index].img}
                            alt="Img"
                            className="w-full h-full object-cover"
                          />
                          <div
                            onClick={() => handleTailoredexpimageDelete(index)}
                            className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
                          >
                            <MdDelete size={18} />
                          </div>

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/webp"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const newData = [...tailoredExpData];
                                  newData[index].img =
                                    URL.createObjectURL(file); // preview
                                  newData[index].file = file; // actual File for backend
                                  setTailoredExpData(newData);
                                }
                              }}
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/webp"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const newData = [...tailoredExpData];
                                newData[index].img = URL.createObjectURL(file);
                                newData[index].file = file;
                                setTailoredExpData(newData);
                              }
                            }}
                            className="hidden"
                          />
                        </label>
                      )}
                    </div>
                  </div>
                ))}
              </Carousel>

              <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
                <FaChevronLeft
                  onClick={handlePrevSlide}
                  className="cursor-pointer"
                />
                Showing {(activeCardIndex % TailoredExpCarousel.length) + 1} /
                {TailoredExpCarousel.length}
                <FaChevronRight
                  onClick={handleNextSlide}
                  className="cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 mb-5">
          {submitError && (
            <p className="text-red-600 text-sm mt-4">{submitError}</p>
          )}

          <div className="grid grid-cols-2 gap-3 mt-10 w-72 mx-auto">
            <button
              type="button"
              onClick={() => navigate("/Properties")}
              className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
            >
              Cancel
            </button>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TestEditPropertyDetailElementor;

//==============================Working Code==========================
// import { useEffect, useRef, useState } from "react";
// import Menubar from "../Menubar/Menubar";
// import { Outlet } from "react-router-dom";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
// import { FaChevronRight } from "react-icons/fa6";
// import { FaChevronLeft } from "react-icons/fa6";
// import { FcAddImage } from "react-icons/fc";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import { Check } from "lucide-react";
// import { MdDelete } from "react-icons/md";

// const TestEditPropertyDetailElementor = () => {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   const navigate = useNavigate();
//   const routerLocation = useLocation();
//   const { id: paramId } = useParams();
//   const propertyid = routerLocation.state?.propertyid ?? paramId;

//   const [isLoadingProperty, setIsLoadingProperty] = useState(true);
//   const [loadError, setLoadError] = useState("");

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const savedState = localStorage.getItem("menubarOpen");

//     if (savedState !== null) {
//       return JSON.parse(savedState);
//     }

//     return window.innerWidth >= 1024;
//   });
//   const [indiaStates, setIndiaStates] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [cities, setCities] = useState([]);

//   useEffect(() => {
//     // Load world.json from public folder
//     fetch("/world.json")
//       .then((res) => res.json())
//       .then((data) => {
//         const india = data.find((country) => country.name === "India");
//         if (india) {
//           setIndiaStates(india.states);
//         }
//       })
//       .catch((err) => console.error("Error loading world.json:", err));
//   }, []);

//   const handleStateChange = (e) => {
//     const stateName = e.target.value;
//     setSelectedState(stateName);

//     if (stateName.toLowerCase() === "goa") {
//       const goaCities = [
//         "Aldona",
//         "Arambol",
//         "Baga",
//         "Bambolim",
//         "Bandora",
//         "Benaulim",
//         "Calangute",
//         "Candolim",
//         "Carapur",
//         "Cavelossim",
//         "Chicalim",
//         "Chinchinim",
//         "Colovale",
//         "Colva",
//         "Cortalim",
//         "Cuncolim",
//         "Curchorem",
//         "Curti",
//         "Davorlim",
//         "Dicholi",
//         "Goa Velha",
//         "Guirim",
//         "Jua",
//         "Kankon",
//         "Madgaon",
//         "Мариса",
//         "Morjim",
//         "Mormugao",
//         "Navelim",
//         "North Goa",
//         "Palle",
//         "Panaji",
//         "Pernem",
//         "Ponda",
//         "Quepem",
//         "Queula",
//         "Raia",
//         "Saligao",
//         "Sancoale",
//         "Sanguem",
//         "Sanquelim",
//         "Sanvordem",
//         "Serula",
//         "Solim",
//         "South Goa",
//         "Taleigao",
//         "Vagator",
//         "Valpoy",
//         "Varca",
//         "Vasco da Gama",
//         // Extra villages
//         "Anjuna",
//         "Arpora",
//         "Assagao",
//         "Parra",
//         "Siolim",
//         "Reis Magos",
//         "Nerul",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(goaCities.map((city, idx) => ({ id: idx + 1, name: city })));
//     } else if (stateName.toLowerCase() === "karnataka") {
//       const karnatakaCities = [
//         // Extra villages

//         // Added cities
//         "Afzalpur",
//         "Ajjampur",
//         "Aland",
//         "Alnavar",
//         "lark",
//         "Alur",
//         "Anekal",
//         "Ankola",
//         "Annigeri",
//         "Arkalgud",
//         "Arsikere",
//         "Athni",
//         "Aurad",
//         "Badami",
//         "Bagalkot",
//         "Bagepalli",
//         "Bail-Hongal",
//         "Ballari",
//         "Banavar",
//         "Bangarapet",
//         "Bannur",
//         "Bantval",
//         "Basavakalyan",
//         "Basavana Bagevadi",
//         "Belagavi",
//         "Belluru",
//         "Beltangadi",
//         "Belur",
//         "Bengaluru",
//         "Bengaluru Rural",
//         "Bengaluru Urban",
//         "Bhadravati",
//         "Bhalki",
//         "Bhatkal",
//         "Bidar",
//         "Bilgi",
//         "Birur",
//         "Byadgi",
//         "Byndoor",
//         "Canacona",
//         "Challakere",
//         "Chamrajnagar",
//         "Channagiri",
//         "Channapatna",
//         "Channarayapatna",
//         "Chik Ballapur",
//         "Chikkaballapur",
//         "Chikkamagaluru",
//         "Chiknayakanhalli",
//         "Chikodi",
//         "Chincholi",
//         "Chintamani",
//         "Chitapur",
//         "Chitradurga",
//         "Closepet",
//         "Coondapoor",
//         "Coorg",
//         "Dakshina Kannada",
//         "Dandeli",
//         "Davanagere",
//         "Devanhalli",
//         "Dharwad",
//         "Dod Ballapur",
//         "French Rocks",
//         "Gadag",
//         "Gadag-Betageri",
//         "Gajendragarh",
//         "Gangawati",
//         "Gangolli",
//         "Gokak",
//         "Gokarna",
//         "Goribidnur",
//         "Gorur",
//         "Gubbi",
//         "Gudibanda",
//         "Guledagudda",
//         "Gundlupet",
//         "Gurmatkal",
//         "Hadagalli",
//         "Haliyal",
//         "Hampi",
//         "Hangal",
//         "Harihar",
//         "Harpanahalli",
//         "Hassan",
//         "Haveri",
//         "Heggadadevankote",
//         "Hirekerur",
//         "Hiriyur",
//         "Holalkere",
//         "Hole Narsipur",
//         "Homnabad",
//         "Honavar",
//         "Honnali",
//         "Hosanagara",
//         "Hosangadi",
//         "Hosdurga",
//         "Hoskote",
//         "Hospet",
//         "Hubballi",
//         "Hukeri",
//         "Hungund",
//         "Hunsur",
//         "Ilkal",
//         "Indi",
//         "Jagalur",
//         "Jamkhandi",
//         "Jevargi",
//         "Kabini",
//         "Kadur",
//         "Kalaburgi",
//         "Kalghatgi",
//         "Kampli",
//         "Kankanhalli",
//         "Karkala",
//         "Karwar",
//         "Kavalur",
//         "Kerur",
//         "Khanapur",
//         "Kodagu",
//         "Kodigenahalli",
//         "Kodlipet",
//         "Kolar",
//         "Kollegal",
//         "Konanur",
//         "Konnur",
//         "Koppa",
//         "Koppal",
//         "Koratagere",
//         "Kotturu",
//         "Krishnarajpet",
//         "Kudachi",
//         "Kudligi",
//         "Kumsi",
//         "Kumta",
//         "Kundgol",
//         "Kunigal",
//         "Kurgunta",
//         "Kushalnagar",
//         "Kushtagi",
//         "Lakshmeshwar",
//         "Lingsugur",
//         "Londa",
//         "Machare",
//         "Maddagiri",
//         "Maddur",
//         "Madikeri",
//         "Magadi",
//         "Mahalingpur",
//         "Malavalli",
//         "Malpe",
//         "Malur",
//         "Mandya",
//         "Mangaluru",
//         "Manipal",
//         "Manvi",
//         "Mayakonda",
//         "Melukote",
//         "Mudbidri",
//         "Muddebihal",
//         "Mudgal",
//         "Mudgere",
//         "Mudhol",
//         "Mulbagal",
//         "Mulgund",
//         "Mulki",
//         "Mundargi",
//         "Mundgod",
//         "Munirabad",
//         "Murudeshwara",
//         "Mysuru",
//         "Nagamangala",
//         "Nanjangud",
//         "Narasimharajapura",
//         "Naregal",
//         "Nargund",
//         "Navalgund",
//         "Nelamangala",
//         "Nyamti",
//         "Pangala",
//         "Pavugada",
//         "Piriyapatna",
//         "Ponnampet",
//         "Puttur",
//         "Rabkavi",
//         "Raichur",
//         "Ramanagara",
//         "Ranibennur",
//         "Raybag",
//         "Robertsonpet",
//         "Ron",
//         "Sadalgi",
//         "Sagar",
//         "Sakleshpur",
//         "Sandur",
//         "Sanivarsante",
//         "Sankeshwar",
//         "Sargur",
//         "Saundatti",
//         "Savanur",
//         "Seram",
//         "Shahabad",
//         "Shahpur",
//         "Shiggaon",
//         "Shikarpur",
//         "Shimoga",
//         "Shirhatti",
//         "Shorapur",
//         "Shrirangapattana",
//         "Siddapur",
//         "Sidlaghatta",
//         "Sindgi",
//         "Sindhnur",
//         "Sira",
//         "Sirsi",
//         "Siruguppa",
//         "Someshwar",
//         "Somvarpet",
//         "Sorab",
//         "Sravana Belgola",
//         "Sringeri",
//         "Srinivaspur",
//         "Sulya",
//         "Suntikoppa",
//         "Talikota",
//         "Tarikere",
//         "Tekkalakote",
//         "Terdal",
//         "Tiptur",
//         "Tirthahalli",
//         "Tirumakudal Narsipur",
//         "Tumakuru",
//         "Turuvekere",
//         "Udupi",
//         "Ullal",
//         "Uttar Kannada",
//         "Vadigenhalli",
//         "Vijayapura",
//         "Virarajendrapet",
//         "Wadi",
//         "Yadgir",
//         "Yelahanka",
//         "Yelandur",
//         "Yelbarga",
//         "Yellapur",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(
//         karnatakaCities.map((city, idx) => ({ id: idx + 1, name: city })),
//       );
//     } else if (stateName.toLowerCase() === "kerala") {
//       const keralaCities = [
//         "Adoor",
//         "Alappuzha",
//         "Alleppey",
//         "Aluva",
//         "Alwaye",
//         "Angamali",
//         "Aroor",
//         "Arukutti",
//         "Attingal",
//         "Avanoor",
//         "Azhikkal",
//         "Beypore",
//         "Changanacheri",
//         "Chelakara",
//         "Chengannur",
//         "Cherpulassery",
//         "Cherthala",
//         "Chetwayi",
//         "Chittur",
//         "Cochin",
//         "Dharmadom",
//         "Edakkulam",
//         "Elur",
//         "Erattupetta",
//         "Ernakulam",
//         "Ferokh",
//         "Guruvayur",
//         "Idukki",
//         "Iringal",
//         "Irinjalakuda",
//         "Kadakkavoor",
//         "Kalamassery",
//         "Kalavoor",
//         "Kalpetta",
//         "Kanhangad",
//         "Kannavam",
//         "Kannur",
//         "Kasaragod",
//         "Kattanam",
//         "Kayankulam",
//         "Kizhake Chalakudi",
//         "Kochi",
//         "Kodungallur",
//         "Kollam",
//         "Kotamangalam",
//         "Kottayam",
//         "Kovalam",
//         "Kozhikode",
//         "Kumbalam",
//         "Kunnamangalam",
//         "Kunnamkulam",
//         "Kunnumma",
//         "Kutiatodu",
//         "Kuttampuzha",
//         "Lalam",
//         "Mahe",
//         "Malappuram",
//         "Manjeri",
//         "Manjeshwaram",
//         "Mannarakkat",
//         "Marayur",
//         "Mattanur",
//         "Mavelikara",
//         "Mavoor",
//         "Muluppilagadu",
//         "Munnar",
//         "Muvattupula",
//         "Muvattupuzha",
//         "Nadapuram",
//         "Naduvannur",
//         "Nedumangad",
//         "Neyyattinkara",
//         "Nileshwar",
//         "Ottappalam",
//         "Palackattumala",
//         "Palakkad district",
//         "Palghat",
//         "Panamaram",
//         "Pappinissheri",
//         "Paravur Tekkumbhagam",
//         "Pariyapuram",
//         "Pathanamthitta",
//         "Pattanamtitta",
//         "Payyanur",
//         "Perinthalmanna",
//         "Perumbavoor",
//         "Perumpavur",
//         "Perya",
//         "Piravam",
//         "Ponnani",
//         "Ponmana",
//         "Punalur",
//         "Punnayur",
//         "Ramamangalam",
//         "Shertallai",
//         "Shoranur",
//         "Taliparamba",
//         "Thalassery",
//         "Thalikulam",
//         "Thanniyam",
//         "Thekkady",
//         "Thiruvananthapuram",
//         "Thrissur",
//         "Tirur",
//         "Tiruvalla",
//         "Vaikam",
//         "Varkala",
//         "Vatakara",
//         "Vayalar",
//         "Vettur",
//         "Wayanad",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(keralaCities.map((city, idx) => ({ id: idx + 1, name: city })));
//     } else if (stateName.toLowerCase() === "tamil nadu") {
//       const tamilnaduCities = [
//         // Tamil Nadu cities
//         "Aambur",
//         "Ariyalur",
//         "Arakkonam",
//         "Arani",
//         "Attur",
//         "Avadi",
//         "Batlagundu",
//         "Chengalpattu",
//         "Chennai",
//         "Chidambaram",
//         "Coimbatore",
//         "Courtallam",
//         "Cuddalore",
//         "Coonoor",
//         "Dharapuram",
//         "Dharmapuri",
//         "Dindigul",
//         "Erode",
//         "Gobichettipalayam",
//         "Gudalur",
//         "Gudiyatham",
//         "Hosur",
//         "Jayankondam",
//         "Kallakurichi",
//         "Kanchipuram",
//         "Kanyakumari",
//         "Karaikudi",
//         "Karur",
//         "Kodaikanal",
//         "Kovilpatti",
//         "Krishnagiri",
//         "Kumbakonam",
//         "Madurai",
//         "Manapparai",
//         "Mahabalipuram",
//         "Mayiladuthurai",
//         "Mettupalayam",
//         "Namakkal",
//         "Nagapattinam",
//         "Nagercoil",
//         "Ooty",
//         "Palani",
//         "Pallavaram",
//         "Pattukkottai",
//         "Perambalur",
//         "Pollachi",
//         "Poonamallee",
//         "Pudukkottai",
//         "Rajapalayam",
//         "Ramanathapuram",
//         "Ranipet",
//         "Salem",
//         "Sankagiri",
//         "Sivaganga",
//         "Sivakasi",
//         "Tambaram",
//         "Tenkasi",
//         "Thanjavur",
//         "Theni",
//         "Thiruvallur",
//         "Thiruvarur",
//         "Thoothukudi",
//         "Tindivanam",
//         "Tiruchendur",
//         "Tiruchengode",
//         "Tiruchirappalli",
//         "Tirunelveli",
//         "Tirupathur",
//         "Tiruppur",
//         "Tiruvannamalai",
//         "Udagamandalam",
//         "Udumalpet",
//         "Usilampatti",
//         "Vaniyambadi",
//         "Vellore",
//         "Villupuram",
//         "Virudhunagar",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(
//         tamilnaduCities.map((city, idx) => ({ id: idx + 1, name: city })),
//       );
//     } else {
//       const stateObj = indiaStates.find((s) => s.name === stateName);
//       setCities(stateObj ? stateObj.cities : []);
//     }
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);

//       if (mobile) {
//         setIsSidebarOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const MAX_CARDS = 50;

//   const [selectedImages, setSelectedImages] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   // Category assigned to each banner slide/image (parallel array to selectedImages)
//   const [selectedCategories, setSelectedCategories] = useState(
//     Array(MAX_CARDS).fill(""),
//   );

//   const [activeBannerIndex, setActiveBannerIndex] = useState(0);
//   const [bannerCategoryError, setBannerCategoryError] = useState("");
//   const [showGalleryModal, setShowGalleryModal] = useState(false);
//   const bannerCarouselRef = useRef(null);

//   // Checks whether the slide at `index` is blocking navigation.
//   // Only a NEWLY uploaded file (has `.file`) without a category blocks —
//   // images that were already loaded from the server (no `.file`, e.g.
//   // existing carousel images or converted legacy images) never block, since
//   // legacy images predate the category concept and shouldn't be forced to
//   // pick one just to view/save the rest of the form.
//   const isBannerSlideBlocked = (index) => {
//     return !!selectedImages[index]?.file && !selectedCategories[index];
//   };

//   const CustomLeftArrowBannerCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowBannerCarousel = ({ onClick }) => {
//     const handleNextClick = () => {
//       // Block moving to the next slide until the current slide's image has a category
//       if (isBannerSlideBlocked(activeBannerIndex)) {
//         setBannerCategoryError(
//           "Please select a category for this image before moving to the next slide.",
//         );
//         return;
//       }
//       setBannerCategoryError("");
//       onClick();
//     };

//     return (
//       <button
//         onClick={handleNextClick}
//         className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   // Plain arrows (no category validation) — used by carousels other than the
//   // main banner (e.g. the per-bedroom image carousels below), so they don't
//   // accidentally inherit the banner's category-gate logic.
//   const CustomLeftArrowPlain = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowPlain = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   // Guards against the corrective goToSlide (below) re-triggering this same
//   // handler and causing an oscillation/"stuck" loop.
//   const isCorrectingBannerSlideRef = useRef(false);

//   // Safety net for navigation that bypasses the arrow buttons (swipe, keyboard, dots):
//   // if the previous slide had an image without a category, snap back to it —
//   // but ONLY when moving forward. Moving backward must always be allowed,
//   // otherwise a later incomplete slide permanently blocks the user from ever
//   // navigating back to fix it.
//   const handleBannerAfterChange = (previousSlide, { currentSlide }) => {
//     if (isCorrectingBannerSlideRef.current) {
//       isCorrectingBannerSlideRef.current = false;
//       setActiveBannerIndex(currentSlide);
//       return;
//     }

//     const movingForward = currentSlide > previousSlide;

//     if (movingForward && isBannerSlideBlocked(previousSlide)) {
//       setBannerCategoryError(
//         "Please select a category for this image before moving to the next slide.",
//       );
//       isCorrectingBannerSlideRef.current = true;
//       if (bannerCarouselRef.current) {
//         bannerCarouselRef.current.goToSlide(previousSlide);
//       }
//       setActiveBannerIndex(previousSlide);
//       return;
//     }
//     setBannerCategoryError("");
//     setActiveBannerIndex(currentSlide);
//   };

//   const handleImageUpload = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...selectedImages];
//       // position is index + 1 -> row in `allPropertyImages`
//       updatedImages[index] = { url: imageurl, file };
//       setSelectedImages(updatedImages);
//     }
//   };

//   const handleBannerImageDelete = async (index) => {
//     const img = selectedImages[index];

//     // Clear locally right away for a snappy UI.
//     setSelectedImages((prev) => {
//       const u = [...prev];
//       u[index] = null;
//       return u;
//     });
//     setSelectedCategories((prev) => {
//       const u = [...prev];
//       u[index] = "";
//       return u;
//     });
//     setBannerCategoryError("");

//     // If this was already a persisted image (loaded from the server, no
//     // pending `.file`), delete it from the DB + Cloudflare right now instead
//     // of waiting for the next full-form Save. Freshly-picked-but-not-yet-saved
//     // uploads (has `.file`) were never written anywhere, so nothing to call.
//     if (img?.url && !img?.file && propertyid) {
//       try {
//         const res = await fetch(
//           `https://demo.zorbastays.com/web-backend/property/${propertyid}/image`,
//           {
//             method: "DELETE",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ imageurl: img.url }),
//           },
//         );
//         const data = await res.json();
//         if (!res.ok || !data.success) {
//           throw new Error(data.error || "Failed to delete image");
//         }
//       } catch (err) {
//         console.error("Error deleting image:", err);
//         setSubmitError(
//           "That image was removed here but couldn't be deleted on the server. It may reappear if you don't save.",
//         );
//       }
//     }
//   };

//   // Deletes a Tailored Experience grid image (imagegrid1-4 on propertyImages).
//   // Same idea as handleBannerImageDelete: clear locally right away, and if
//   // this was already a persisted image (a real saved URL, not a fresh
//   // not-yet-saved file), delete it from Cloudflare + null the column now
//   // instead of waiting for the next form Save — Save alone never sends this
//   // field once it's cleared, so without this call the old value would just
//   // sit in the DB untouched.
//   const handleTailoredexpimageDelete = async (index) => {
//     const exp = tailoredExpData[index];
//     const wasPersisted = !!exp?.img && !exp?.file;

//     setTailoredExpData((prev) => {
//       const u = [...prev];
//       u[index] = { ...u[index], img: null, file: null };
//       return u;
//     });

//     if (wasPersisted && propertyid) {
//       try {
//         const res = await fetch(
//           `https://demo.zorbastays.com/web-backend/property/${propertyid}/image`,
//           {
//             method: "DELETE",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               fieldName: `imagegrid${index + 1}`,
//               table: "propertyImages",
//             }),
//           },
//         );
//         const data = await res.json();
//         if (!res.ok || !data.success) {
//           throw new Error(data.error || "Failed to delete image");
//         }
//       } catch (err) {
//         console.error("Error deleting tailored experience image:", err);
//         setSubmitError(
//           "That image was removed here but couldn't be deleted on the server. It may reappear if you don't save.",
//         );
//       }
//     }
//   };

//   const handleBannerCategoryChange = (index, categoryValue) => {
//     setSelectedCategories((prev) => {
//       const u = [...prev];
//       u[index] = categoryValue;
//       return u;
//     });
//     if (categoryValue) {
//       setBannerCategoryError("");
//     }
//   };

//   // Builds the ordered category list, with Bedroom/Bathroom expanded dynamically
//   // based on the "No. of Rooms" (bookingRooms/maxbed) and "Max Bathroom" (maxbath) inputs.
//   const getBannerCategoryOptions = () => {
//     const bedroomCount = parseInt(bookingRooms) || 0;
//     const bathroomCount = parseInt(maxbath) || 0;

//     const bedroomOptions =
//       bedroomCount > 0
//         ? Array.from({ length: bedroomCount }, (_, i) => `Bedroom ${i + 1}`)
//         : ["Bedroom"];

//     const bathroomOptions =
//       bathroomCount > 0
//         ? Array.from({ length: bathroomCount }, (_, i) => `Bathroom ${i + 1}`)
//         : ["Bathroom"];

//     return [
//       "Living Room",
//       "Dining Area",
//       ...bedroomOptions,
//       ...bathroomOptions,
//       "Pool",
//       "Courtyard",
//       "Games & Activity Area",
//       "Exterior",
//       "Jacuzzi",
//       "Theatre Room",
//       "Gym",
//       "Garden",
//       "Kitchen",
//       "Additional Photos",
//     ];
//   };

//   // Groups every selected banner image by its assigned category, for the "View All" gallery.
//   // Categories with no images are omitted.
//   const getGroupedBannerGallery = () => {
//     const grouped = {};
//     getBannerCategoryOptions().forEach((cat) => {
//       grouped[cat] = [];
//     });
//     selectedImages.forEach((img, index) => {
//       const cat = selectedCategories[index];
//       if (img && cat) {
//         if (!grouped[cat]) grouped[cat] = [];
//         grouped[cat].push({ ...img, index });
//       }
//     });
//     return Object.entries(grouped).filter(([, imgs]) => imgs.length > 0);
//   };

//   // Pulls the images assigned to a given bedroom directly from the banner's
//   // selectedImages/selectedCategories (category === "Bedroom {roomIndex + 1}").
//   // This keeps the Bedroom Carousel section below in sync with the banner —
//   // there is no separate upload step here anymore.
//   const getBedroomImages = (roomIndex) => {
//     const categoryLabel = `Bedroom ${roomIndex + 1}`;
//     const images = [];
//     selectedImages.forEach((img, idx) => {
//       if (img && selectedCategories[idx] === categoryLabel) {
//         images.push({ ...img, bannerIndex: idx });
//       }
//     });
//     return images;
//   };

//   const TailoredExpCarousel = [
//     {
//       img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/77613/villa-barbados-caribbean-luxury-the-great-house-boat_FullL.jpg?v=302558110212",
//       title: "For Adventure Seekers",
//       content:
//         "Experience the thrill of Goa with our adventure package! Enjoy cozy stays, a hearty breakfast, and activities like water sports, trekking, and more.",
//     },
//     {
//       img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/66699/villa-barbados-caribbean-luxury-the-great-house-ext-9_FullL.jpg?v=302558110212",
//       title: "For Leisure Lovers",
//       content:
//         "Unwind with our leisure package in Goa. Relax in serene stays, savor a delicious breakfast, and enjoy peaceful beaches, spa sessions, and local attractions.",
//     },
//   ];

//   const responsive_TailoredExpCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_OuterCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 3,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 3,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_BannerCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const [showDots, setShowDots] = useState(false);

//   useEffect(() => {
//     const updateDotsVisibility = () => {
//       setShowDots(window.innerWidth < 768);
//     };

//     updateDotsVisibility();
//     window.addEventListener("resize", updateDotsVisibility);
//     return () => window.removeEventListener("resize", updateDotsVisibility);
//   }, []);

//   const responsive_ImageCarouselOne = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const CustomLeftArrowTailoredExpCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-44 transform -translate-y-1/2 shadow-custom bg-white bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowTailoredExpCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute right-3 top-44 transform -translate-y-1/2 shadow-custom bg-white bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   const [activeCardIndex, setActiveCardIndex] = useState(0);
//   const carouselRef = useRef(null);

//   const handlePrevSlide = () => {
//     if (carouselRef.current) {
//       carouselRef.current.previous();
//     }
//   };

//   const handleNextSlide = () => {
//     if (carouselRef.current) {
//       carouselRef.current.next();
//     }
//   };

//   const [, setIsOpen_dropdownExp] = useState(false);
//   const dropdownRef_dropdownExp = useRef(null);

//   useEffect(() => {
//     const handleClickOutside_dropdownExp = (event) => {
//       if (
//         dropdownRef_dropdownExp.current &&
//         !dropdownRef_dropdownExp.current.contains(event.target)
//       ) {
//         setIsOpen_dropdownExp(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside_dropdownExp);
//     return () =>
//       document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
//   }, []);
//   const [tailoredExpData, setTailoredExpData] = useState([
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//   ]);
//   const MAX_CARDS_Exp = tailoredExpData.length;

//   // Booking Widget States
//   const [bookingPrice, setBookingPrice] = useState("");
//   const [bookingPriceDetails, setBookingPriceDetails] = useState(
//     "(for 10 rooms) Per Night + Taxes",
//   );
//   const [bookingcheckinDate, setBookingcheckinDate] = useState("");
//   const [bookingcheckintime, setBookingcheckintime] = useState("");
//   const [bookingcheckoutDate, setBookingcheckoutDate] = useState("");
//   const [bookingcheckouttime, setBookingcheckouttime] = useState("");
//   const [bookingAdults, setBookingAdults] = useState("2");
//   const [bookingChildren, setBookingChildren] = useState("0");
//   const [bookingRooms, setBookingRooms] = useState("3");
//   const [bookingTotal, setBookingTotal] = useState("");

//   const [propertyname, setpropertyname] = useState("");
//   const [description, setDescription] = useState("");
//   const [heading, setHeading] = useState("");
//   const [content, setContent] = useState("");
//   const [catchyQuote, setCatchyQuote] = useState("");
//   const [maptitle, setmaptitle] = useState("");
//   const [mapcontent, setmapcontent] = useState("");
//   const [tailoredExperience, setTailoredExperience] = useState("");
//   const [tailoredExperienceContent, setTailoredExperienceContent] =
//     useState("");

//   const [maplang, setmaplang] = useState("");
//   const [maplong, setmaplong] = useState("");

//   // Additional required data (not shown on website)
//   const [propertycode, setpropertycode] = useState("");
//   const [propertyowner, setpropertyowner] = useState("");
//   const [airid, setairid] = useState("");
//   const [instagramreellink, setinstagramreellink] = useState("");
//   const [propertyBrochure, setPropertyBrochure] = useState("");
//   const [defaultprice, setdefaultprice] = useState("");
//   const [deposit, setDeposit] = useState("");
//   const [maxbath, setmaxbath] = useState("");
//   const [maplink, setMaplink] = useState("");
//   const [youtubelink, setYoutubelink] = useState("");
//   const [seasonType, setSeasonType] = useState("");
//   const [propertytype, setpropertytype] = useState("Villa");
//   const [location, setLocation] = useState("");
//   const [rating, setRating] = useState("");

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState("");

//   const [amenitiesList, setAmenitiesList] = useState([]);
//   const [selectedAmenities, setSelectedAmenities] = useState([]); // stores ids: [1, 4, 5]

//   const [searchTerm, setSearchTerm] = useState("");
//   const [isOpen_amenities, setIsOpen_amenities] = useState(false);

//   useEffect(() => {
//     // Mock amenities
//     setAmenitiesList([
//       { id: 1, name: "WiFi" },
//       { id: 2, name: "Swimming Pool" },
//       { id: 3, name: "Air Conditioning" },
//       { id: 4, name: "Kitchen" },
//       { id: 5, name: "Free Parking" },
//     ]);
//   }, []);

//   // Toggle stores/removes the numeric id
//   const toggleAmenity = (id) => {
//     setSelectedAmenities((prev) =>
//       prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id],
//     );
//   };

//   const filteredAmenities = amenitiesList.filter((amenity) =>
//     amenity.name.toLowerCase().includes(searchTerm.toLowerCase()),
//   );

//   const containerRef_amenities = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         containerRef_amenities.current &&
//         !containerRef_amenities.current.contains(event.target)
//       ) {
//         setIsOpen_amenities(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // ─── Fetch existing property + autofill the form ───
//   useEffect(() => {
//     if (!propertyid) {
//       setIsLoadingProperty(false);
//       setLoadError(
//         "No property selected to edit — missing propertyid (check the navigate() call that opened this page).",
//       );
//       return;
//     }

//     const loadProperty = async () => {
//       setIsLoadingProperty(true);
//       setLoadError("");
//       try {
//         const res = await fetch(
//           `https://demo.zorbastays.com/web-backend/admin/properties/${propertyid}`,
//         );
//         if (!res.ok) throw new Error("Failed to load property");
//         const p = await res.json();

//         // ── Simple fields ──
//         setpropertyname(p.propertyname || "");
//         setDescription(p.description || "");
//         setHeading(p.heading || "");
//         setContent(p.content || "");
//         setCatchyQuote(p.catchquote || "");
//         setmaptitle(p.maptitle || "");
//         setmapcontent(p.mapcontent || "");
//         setmaplang(p.maplang ?? "");
//         setmaplong(p.maplong ?? "");
//         setpropertycode(p.propertycode || "");
//         setpropertyowner(p.propertyowner || "");
//         setairid(p.airid || "");
//         setinstagramreellink(p.instagramreellink || "");
//         setPropertyBrochure(p.propertyBrochure || "");
//         setBookingPrice(p.currentprice ?? "");
//         setdefaultprice(p.defaultprice ?? "");
//         setDeposit(p.deposit ?? "");
//         setBookingAdults(String(p.maxadult ?? "2"));
//         setBookingChildren(String(p.maxchild ?? "0"));
//         setBookingRooms(String(p.maxbed ?? "3"));
//         setmaxbath(String(p.maxbath ?? ""));
//         setMaplink(p.maplink || "");
//         setYoutubelink(p.youtubelink || "");
//         setSeasonType(p.seasonType || "");
//         setpropertytype(p.propertytype || "Villa");
//         setSelectedState(p.destination || "");
//         setLocation(p.location || "");
//         setRating(p.rating ?? "");

//         // ── Amenities (stored as comma-joined ids string) ──
//         if (p.addons) {
//           setSelectedAmenities(
//             String(p.addons)
//               .split(",")
//               .map((v) => parseInt(v, 10))
//               .filter((v) => !isNaN(v)),
//           );
//         }

//         // ── Tailored experience ──
//         setTailoredExperience(p.expnamemain || "");
//         setTailoredExperienceContent(p.expcontentmain || "");
//         setTailoredExpData([
//           { img: p.imagegrid1 || null, title: "", content: "" },
//           { img: p.imagegrid2 || null, title: "", content: "" },
//           { img: p.imagegrid3 || null, title: "", content: "" },
//           { img: p.imagegrid4 || null, title: "", content: "" },
//         ]);

//         // ── Merged top carousel ──
//         // Every property's images now live in allPropertyImages, so this is
//         // the same simple fill-in for every property, old or new.
//         const images = Array.isArray(p.images) ? p.images : [];
//         const filledImages = Array(MAX_CARDS).fill(null);
//         const filledCategories = Array(MAX_CARDS).fill("");

//         images.forEach((img, i) => {
//           if (i >= MAX_CARDS) return; // guard against more images than slots
//           filledImages[i] = { url: img.imageurl, file: null };
//           filledCategories[i] = img.category || "";
//         });

//         setSelectedImages(filledImages);
//         setSelectedCategories(filledCategories);
//       } catch (err) {
//         console.error("Error loading property:", err);
//         setLoadError(err.message || "Failed to load property");
//       } finally {
//         setIsLoadingProperty(false);
//       }
//     };

//     loadProperty();
//   }, [propertyid]);

//   const handleSubmit = async () => {
//     setSubmitError("");

//     if (
//       !propertyname ||
//       !propertycode ||
//       !propertytype ||
//       !selectedState ||
//       !location
//     ) {
//       setSubmitError("Please fill all required (*) fields before saving.");
//       return;
//     }

//     const uncategorizedBannerIndex = selectedImages.findIndex(
//       (img, index) => img?.file && !selectedCategories[index],
//     );
//     if (uncategorizedBannerIndex !== -1) {
//       setSubmitError(
//         `Please select a category for banner slide ${uncategorizedBannerIndex + 1} before saving.`,
//       );
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const formData = new FormData();

//       // ── Simple text fields -> `properties` table ──
//       formData.append("propertyname", propertyname);
//       formData.append("description", description);
//       formData.append("heading", heading);
//       formData.append("content", content);
//       formData.append("catchquote", catchyQuote);
//       formData.append("maplang", maplang);
//       formData.append("maplong", maplong);
//       formData.append("propertycode", propertycode);
//       formData.append("propertyowner", propertyowner);
//       formData.append("airid", airid);
//       formData.append("instagramreellink", instagramreellink);
//       formData.append("propertyBrochure", propertyBrochure);
//       formData.append("currentprice", bookingPrice);
//       formData.append("defaultprice", defaultprice);
//       formData.append("deposit", deposit);
//       formData.append("maxadult", bookingAdults);
//       formData.append("maxchild", bookingChildren);
//       formData.append("maxbed", bookingRooms);
//       formData.append("maxbath", maxbath);
//       formData.append("maplink", maplink);
//       formData.append("youtubelink", youtubelink);
//       formData.append("seasonType", seasonType);
//       formData.append("propertytype", propertytype);
//       formData.append("destination", selectedState);
//       formData.append("location", location);

//       // ── Map / propertyImages text fields ──
//       formData.append("maptitle", maptitle);
//       formData.append("mapcontent", mapcontent);

//       // ── Amenities (ids) ──
//       formData.append("amenities", JSON.stringify(selectedAmenities));

//       // ── Tailored experience ──
//       formData.append("expnamemain", tailoredExperience);
//       formData.append("expcontentmain", tailoredExperienceContent);

//       // ── Merged top carousel ──
//       // allPropertyImages is the source of truth for every property now.
//       // Slides with a fresh upload go through banner_<position>(+_category);
//       // slides that are unchanged (already-saved image, no new file) are
//       // passed back as `existingImages` JSON so the backend keeps them
//       // instead of deleting them when it rebuilds the table.
//       const existingImages = [];
//       selectedImages.forEach((img, index) => {
//         if (!img) return;
//         const position = index + 1;
//         if (img.file) {
//           formData.append(`banner_${position}`, img.file);
//           formData.append(
//             `banner_${position}_category`,
//             selectedCategories[index] || "",
//           );
//         } else {
//           existingImages.push({
//             imageurl: img.url,
//             position,
//             category: selectedCategories[index] || "",
//           });
//         }
//       });
//       formData.append("existingImages", JSON.stringify(existingImages));

//       // ── Tailored experience images -> `experiences` (imagegrid1..4) ──
//       // New uploads go as files; unchanged ones are passed back as plain URL
//       // strings; cleared ones are sent as an explicit empty string so the
//       // backend can tell "untouched" apart from "deleted" and null the
//       // column on save too (belt-and-suspenders alongside the instant
//       // delete call in handleTailoredexpimageDelete).
//       tailoredExpData.forEach((exp, index) => {
//         if (exp?.file) {
//           formData.append(`expimage${index + 1}`, exp.file);
//         } else {
//           formData.append(`imagegrid${index + 1}`, exp?.img || "");
//         }
//       });

//       const response = await fetch(
//         `https://demo.zorbastays.com/web-backend/${propertyid}`,
//         {
//           method: "PUT",
//           body: formData,
//         },
//       );

//       const data = await response.json();

//       if (!response.ok || !data.success) {
//         throw new Error(data.error || "Failed to update property");
//       }

//       setIsSubmitting(false);
//       navigate("/Properties");
//     } catch (err) {
//       console.error("Error saving property:", err);
//       setSubmitError(err.message || "Something went wrong while saving.");
//       setIsSubmitting(false);
//     }
//   };

//   if (isLoadingProperty) {
//     return (
//       <div className="flex items-center justify-center w-full h-screen text-gray-500">
//         Loading property…
//       </div>
//     );
//   }

//   if (loadError) {
//     return (
//       <div className="flex flex-col items-center justify-center w-full h-screen text-red-600 gap-3">
//         <p>{loadError}</p>
//         <button
//           onClick={() => navigate("/Properties")}
//           className="px-4 py-2 bg-gray-800 text-white rounded-lg text-sm"
//         >
//           Back to Properties
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div
//       className={`flex bg-[#F8F9FA] transition-all duration-500 ${
//         isMobile ? "ml-0" : isSidebarOpen ? "w-[82vw]" : "w-[95vw]"
//       }`}
//     >
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${
//           isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
//         }`}
//       >
//         <Outlet />

//         {/* Header */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
//             <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//               Add New Property
//             </p>
//           </div>
//         </div>

//         {/* Data not to be shown in website */}
//         <div className="mt-10">
//           <p className="text-lg text-center mb-6">
//             Required Data <i>(not to be displayed on the website)</i>
//           </p>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5">
//             <div className="flex flex-col w-full">
//               {/* goes to table properties as propertycode */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property Code <sub className="text-red-500 text-base">*</sub>
//               </label>
//               <input
//                 placeholder="Enter property code"
//                 name="propertycode"
//                 required
//                 value={propertycode}
//                 onChange={(e) => setpropertycode(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as propertyowner */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property's Owner name
//               </label>
//               <input
//                 placeholder="Enter Owner's name"
//                 name="propertyowner"
//                 value={propertyowner}
//                 onChange={(e) => setpropertyowner(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>
//             <div className="flex flex-col w-full">
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property ID
//               </label>
//               <input
//                 placeholder="Enter Airbnb ID"
//                 name="airid"
//                 value={airid}
//                 onChange={(e) => setairid(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>
//             <div className="flex flex-col w-full">
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Instagram Reel Link
//               </label>
//               <input
//                 placeholder="Enter Instagram Reel Link"
//                 name="instagramreellink"
//                 value={instagramreellink}
//                 onChange={(e) => setinstagramreellink(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>
//             <div className="flex flex-col w-full">
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property Brochure
//               </label>
//               <input
//                 placeholder="Enter Drive Link"
//                 name="propertyBrochure"
//                 value={propertyBrochure}
//                 onChange={(e) => setPropertyBrochure(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as defaultprice */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Default Price
//               </label>
//               <input
//                 placeholder="Enter default price"
//                 name="defaultprice"
//                 value={defaultprice}
//                 onChange={(e) => setdefaultprice(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as deposit */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Security Deposit
//               </label>
//               <input
//                 placeholder="Enter security deposit"
//                 name="deposit"
//                 value={deposit}
//                 onChange={(e) => setDeposit(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxadult
//                   Synced with "Guests" (Adults) in the Booking Widget below —
//                   both read/write the same `bookingAdults` state. */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Adults
//               </label>
//               <input
//                 type="number"
//                 placeholder="Enter max adults"
//                 name="maxadult"
//                 value={bookingAdults}
//                 onChange={(e) => setBookingAdults(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxchild
//                   Synced with "Guests" (Children) in the Booking Widget below —
//                   both read/write the same `bookingChildren` state. */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Children
//               </label>
//               <input
//                 type="number"
//                 placeholder="Enter max children"
//                 name="maxchild"
//                 value={bookingChildren}
//                 onChange={(e) => setBookingChildren(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxbed
//                   Synced with "No. of Rooms" in the Booking Widget below —
//                   both read/write the same `bookingRooms` state, so changing
//                   either one updates the other automatically. */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Bedroom
//               </label>
//               <input
//                 type="number"
//                 placeholder="Enter max bedroom"
//                 name="maxbed"
//                 value={bookingRooms}
//                 onChange={(e) => setBookingRooms(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxbath */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Bathroom
//               </label>
//               <input
//                 placeholder="Enter max bathroom"
//                 name="maxbath"
//                 value={maxbath}
//                 onChange={(e) => setmaxbath(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maplink */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Map Location
//               </label>
//               <input
//                 placeholder="Enter map location"
//                 name="maplink"
//                 value={maplink}
//                 onChange={(e) => setMaplink(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as youtubelink */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Youtube Link
//               </label>
//               <input
//                 placeholder="Enter youtube link"
//                 name="youtubelink"
//                 value={youtubelink}
//                 onChange={(e) => setYoutubelink(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as seasonType */}
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Season Type
//               </label>

//               <select
//                 name="seasonType"
//                 value={seasonType}
//                 onChange={(e) => setSeasonType(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="">Select season type</option>
//                 <option value="Summer">Summer</option>
//                 <option value="Winter">Winter</option>
//                 <option value="Monsoon">Monsoon</option>
//               </select>
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as propertytype */}
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Property Type<sub className="text-red-500 text-base">*</sub>
//               </label>

//               <select
//                 name="propertytype"
//                 required
//                 value={propertytype}
//                 onChange={(e) => setpropertytype(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="Villa">Villa</option>
//               </select>
//             </div>

//             {/* Destination (State) */}
//             <div className="flex flex-col w-full">
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Destination<sub className="text-red-500 text-base">*</sub>
//               </label>
//               <select
//                 name="destination"
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 value={selectedState}
//                 onChange={handleStateChange}
//                 required
//               >
//                 <option value="">Select your destination</option>
//                 {indiaStates.map((state) => (
//                   <option key={state.id} value={state.name}>
//                     {state.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Location (City) */}
//             <div className="flex flex-col w-full">
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Select Location <sub className="text-red-500 text-base">*</sub>
//               </label>
//               <select
//                 name="location"
//                 required
//                 value={location}
//                 onChange={(e) => setLocation(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="">Select your location</option>
//                 {cities.map((city) => (
//                   <option key={city.id} value={city.name}>
//                     {city.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="flex flex-col w-full">
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Property Rating
//               </label>

//               <select
//                 name="rating"
//                 required
//                 value={rating}
//                 onChange={(e) => setRating(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="">Enter Rating</option>
//                 <option value="5">5</option>
//                 <option value="4">4</option>
//                 <option value="3">3</option>
//                 <option value="2">2</option>
//                 <option value="1">1</option>
//                 <option value="0">0</option>
//               </select>
//             </div>
//           </div>
//         </div>

//         <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-10 md:my-16 justify-center">
//           <div className="h-[1px] w-full bg-gray-300" />
//           <img
//             src="../assets/zorba_logo.webp"
//             alt="Img"
//             className="h-4 w-auto"
//           />
//           <div className="h-[1px] w-full bg-gray-300" />
//         </div>

//         <div className="my-10">
//           <div className="">
//             <div className="flex flex-col items-center justify-center w-full max-w-3xl mx-auto text-center mt-8">
//               <div className="w-full">
//                 {/* goes to table "properties" as "propertyname" */}
//                 <input
//                   type="text"
//                   name="propertyname"
//                   required
//                   maxLength={50}
//                   value={propertyname}
//                   onChange={(e) => setpropertyname(e.target.value)}
//                   className="w-full text-center text-2xl sm:text-3xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Enter Property Name"
//                 />
//                 <p className="text-xs mt-1 text-center">
//                   {propertyname.length.toString().padStart(2, "0")}/50
//                 </p>
//                 {/* goes to table "properties" as "description" */}
//                 <div className="my-4">
//                   <textarea
//                     rows="2"
//                     name="description"
//                     maxLength={250}
//                     value={description}
//                     onChange={(e) => setDescription(e.target.value)}
//                     className="w-full text-center text-gray-700 text-lg border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     placeholder="Enter Property Description..."
//                   />
//                   <p className="text-xs text-center">
//                     {description.length.toString().padStart(2, "0")}/250
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Banner carousel */}
//             <div className="mt-5 -mx-3 relative">
//               {/* Images are stored in the `allPropertyImages` table with:
//     propertyid, imageurl, and position (1, 2, 3, ...)
// */}

//               <Carousel
//                 ref={bannerCarouselRef}
//                 responsive={responsive_BannerCarousel}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite={false}
//                 keyBoardControl
//                 showDots={false}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//                 afterChange={handleBannerAfterChange}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[58vh] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {selectedImages[index] ? (
//                         <>
//                           <img
//                             src={selectedImages[index]?.url}
//                             alt="Img"
//                             className="w-full h-full object-cover"
//                           />

//                           <div
//                             onClick={() => handleBannerImageDelete(index)}
//                             className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
//                           >
//                             <MdDelete size={18} />
//                           </div>

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/webp"
//                               onChange={(e) => handleImageUpload(e, index)}
//                               className="hidden"
//                             />
//                           </label>

//                           {/* Per-slide category dropdown (mandatory once this slide has an image) */}
//                           <div className="absolute bottom-2 right-24 z-10 flex flex-col items-end">
//                             <select
//                               name={`bannerCategory_${index}`}
//                               value={selectedCategories[index] || ""}
//                               onChange={(e) =>
//                                 handleBannerCategoryChange(
//                                   index,
//                                   e.target.value,
//                                 )
//                               }
//                               className={`text-xs font-medium rounded-md px-2 py-1.5 max-w-[150px] focus:outline-none focus:ring-0 shadow-sm ${
//                                 selectedCategories[index]
//                                   ? "bg-white/90 border border-gray-300 text-gray-800"
//                                   : "bg-red-50/95 border border-red-500 text-red-700"
//                               }`}
//                             >
//                               <option value="">Select category*</option>
//                               {getBannerCategoryOptions().map((cat) => (
//                                 <option key={cat} value={cat}>
//                                   {cat}
//                                 </option>
//                               ))}
//                             </select>
//                           </div>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/webp"
//                             onChange={(e) => handleImageUpload(e, index)}
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       <div className="absolute top-1 left-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>

//               {/* View All button, pinned to the banner's bottom-right corner (stays put while slides change) */}
//               <button
//                 type="button"
//                 onClick={() => setShowGalleryModal(true)}
//                 className="absolute z-20 bottom-2.5 right-6 px-4 py-[7.5px] bg-green-800 hover:bg-green-700 rounded-md text-white text-xs font-medium shadow-sm transition-colors"
//               >
//                 View All
//               </button>

//               {bannerCategoryError && (
//                 <p className="absolute z-20 bottom-14 right-3 bg-red-600 text-white text-xs px-3 py-1.5 rounded shadow-sm max-w-xs text-right">
//                   {bannerCategoryError}
//                 </p>
//               )}
//             </div>
//           </div>

//           {/* View All Gallery Modal */}
//           {showGalleryModal && (
//             <div
//               className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
//               onClick={() => setShowGalleryModal(false)}
//             >
//               <div
//                 className="bg-white rounded-xl w-full max-w-5xl max-h-[85vh] overflow-y-auto pt-0 p-6 relative"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <button
//                   type="button"
//                   onClick={() => setShowGalleryModal(false)}
//                   className="sticky top-3 ml-auto block z-50 text-gray-500 hover:text-black text-xl font-semibold px-2"
//                 >
//                   ✕
//                 </button>

//                 {getGroupedBannerGallery().length === 0 ? (
//                   <p className="text-gray-500 text-sm">
//                     No images have been assigned a category yet.
//                   </p>
//                 ) : (
//                   getGroupedBannerGallery().map(([category, images]) => (
//                     <div key={category} className="mb-8">
//                       <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b border-gray-100 pb-2">
//                         {category}{" "}
//                         <span className="text-sm font-normal text-gray-400">
//                           ({images.length})
//                         </span>
//                       </h3>
//                       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
//                         {images.map((img) => (
//                           <div
//                             key={img.index}
//                             className="aspect-square rounded-lg overflow-hidden border border-gray-200"
//                           >
//                             <img
//                               src={img.url}
//                               alt={category}
//                               className="w-full h-full object-cover"
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>
//           )}

//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10">
//             <div className="lg:col-span-2">
//               <div className="grid grid-cols-1">
//                 <div className="order-1 lg:order-2 mt-5 lg:mt-10 text-left">
//                   {/* goes to table "properties" as "heading" */}
//                   <input
//                     type="text"
//                     maxLength={100}
//                     value={heading}
//                     onChange={(e) => setHeading(e.target.value)}
//                     className="fontPD flex w-full text-left text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     style={{
//                       letterSpacing: "1px",
//                       wordSpacing: "2px",
//                       lineHeight: 1.3,
//                     }}
//                     placeholder="Heading"
//                   />
//                   <p className="text-xs text-left block mt-1">
//                     {heading.length.toString().padStart(2, "0")}/100
//                   </p>

//                   {/* goes to table "properties" as "content" */}
//                   <div className="my-5 lg:my-10">
//                     <textarea
//                       type="text"
//                       rows="3"
//                       maxLength={400}
//                       value={content}
//                       onChange={(e) => setContent(e.target.value)}
//                       className="flex w-full text-left border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       placeholder="Content..."
//                     />
//                     <span className="text-xs block mt-1">
//                       {content.length.toString().padStart(2, "0")}/400
//                     </span>
//                   </div>
//                 </div>
//                 {/* goes to table "properties" as "catchquote" */}

//                 <div className="mt-5 lg:mt-0 order-3">
//                   <input
//                     type="text"
//                     maxLength={100}
//                     value={catchyQuote}
//                     onChange={(e) => setCatchyQuote(e.target.value)}
//                     className="flex w-full md:text-xl text-left border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     placeholder="Catchy Quote"
//                   />
//                   <p className="text-xs text-left block mt-1">
//                     {catchyQuote.length.toString().padStart(2, "0")}/100
//                   </p>

//                   <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-5 justify-center">
//                     <div className="h-[1px] w-full bg-gray-300" />
//                     <img
//                       src="../assets/zorba_logo.webp"
//                       alt="Img"
//                       className="h-4 w-auto"
//                     />
//                     <div className="h-[1px] w-full bg-gray-300" />
//                   </div>
//                 </div>
//               </div>
//               {/* Carousel of Amenities Experience */}
//               <div className="mt-5 mb-10" ref={containerRef_amenities}>
//                 <div className="text-center mb-4">
//                   <h2 className="text-2xl font-semibold">Amenities</h2>
//                   <p className="text-gray-500 mt-1">
//                     {selectedAmenities.length} selected
//                   </p>
//                 </div>

//                 <input
//                   type="text"
//                   placeholder="Search amenities..."
//                   className="w-full mb-4 px-4 py-3 border rounded-lg focus:outline-none focus:ring-0 focus:border-[1.5px] focus:border-black"
//                   value={searchTerm}
//                   onFocus={() => setIsOpen_amenities(true)}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />

//                 {isOpen_amenities && (
//                   <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 overflow-y-auto max-h-96">
//                     {filteredAmenities.map((amenity, index) => {
//                       const isSelected = selectedAmenities.includes(amenity.id);

//                       return (
//                         <div
//                           key={index}
//                           onClick={() => toggleAmenity(amenity.id)}
//                           className={`relative cursor-pointer rounded-xl border px-3 py-5 transition-all duration-200
//                         ${
//                           isSelected
//                             ? "border-black shadow-md"
//                             : "border-gray-200 hover:border-gray-400"
//                         }`}
//                         >
//                           {/* Tick */}
//                           {isSelected && (
//                             <div className="absolute top-3 right-3 bg-green-800 text-white rounded-full p-1">
//                               <Check size={16} />
//                             </div>
//                           )}

//                           {/* Icon */}
//                           <img
//                             src="https://www.freeiconspng.com/thumbs/wifi-icon/3d-black-wifi-icon-9.png"
//                             alt={amenity.name}
//                             className="w-auto h-20 mb-3 object-contain"
//                           />

//                           {/* Text */}
//                           <p className="text-base font-medium">
//                             {amenity.name}
//                           </p>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//               {/* Wrapping Carousel for all 5 image categories */}
//               {/* Bedroom Carousel — sourced from the banner images assigned to
//                   "Bedroom 1", "Bedroom 2", ... "Bedroom N" categories above. */}
//               <div className="mt-8 mb-5 border border-gray-200 p-4 rounded-xl shadow-sm bg-gray-50 -mx-3 md:mx-0">
//                 {/*
//   Bedroom structure:
//   - One row per bedroom in `allPropertyBedrooms`
//   • propertyid
//   • position = roomIndex + 1

//   - One row per image in `allPropertyBedroomImages`, sourced from the banner
//     images tagged with category "Bedroom {position}"
//   • bedroomID (FK -> allPropertyBedrooms.id)
//   • imageurl
//   • position = imgIndex + 1
//   */}
//                 <Carousel
//                   key={`bedroom-outer-carousel-${parseInt(bookingRooms) || 1}`}
//                   responsive={responsive_OuterCarousel}
//                   autoPlay={false}
//                   infinite={true}
//                   showDots={true}
//                   keyBoardControl={true}
//                   arrows={false}
//                 >
//                   {Array.from({ length: parseInt(bookingRooms) || 1 }).map(
//                     (_, roomIndex) => {
//                       const images = getBedroomImages(roomIndex);
//                       return (
//                         <div key={roomIndex} className="px-4 pb-8">
//                           <h3 className="text-center font-bold text-lg mb-4">
//                             Bedroom {roomIndex + 1} Images{" "}
//                             <span className="text-sm font-normal text-gray-400">
//                               ({images.length})
//                             </span>
//                           </h3>

//                           {images.length === 0 ? (
//                             <div className="flex flex-col items-center justify-center w-full aspect-[4/3] max-h-[350px] bg-white border-dashed border-2 border-gray-300 rounded-lg text-center px-4">
//                               <p className="text-sm text-gray-400">
//                                 No images assigned yet. Add images in the banner
//                                 above and set their category to "Bedroom{" "}
//                                 {roomIndex + 1}".
//                               </p>
//                             </div>
//                           ) : (
//                             <Carousel
//                               key={`bedroom-inner-carousel-${roomIndex}-${images.length}`}
//                               responsive={responsive_ImageCarouselOne}
//                               autoPlay={false}
//                               autoPlaySpeed={3000}
//                               infinite
//                               keyBoardControl
//                               showDots={showDots}
//                               customLeftArrow={<CustomLeftArrowPlain />}
//                               customRightArrow={<CustomRightArrowPlain />}
//                             >
//                               {images.map((img, imgIndex) => (
//                                 <div key={img.bannerIndex} className="mx-3">
//                                   <div className="flex flex-col items-center justify-between w-full aspect-[4/3] max-h-[350px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                                     <img
//                                       src={img.url}
//                                       alt={`Bedroom ${roomIndex + 1} - ${imgIndex + 1}`}
//                                       className="w-full h-full object-cover"
//                                     />
//                                     <div
//                                       onClick={() =>
//                                         handleBannerImageDelete(img.bannerIndex)
//                                       }
//                                       title="Remove this image from the banner"
//                                       className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
//                                     >
//                                       <MdDelete size={18} />
//                                     </div>
//                                     <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                                       {imgIndex + 1}
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))}
//                             </Carousel>
//                           )}
//                         </div>
//                       );
//                     },
//                   )}
//                 </Carousel>
//               </div>
//               {/* Map */}
//               <div className="mt-12">
//                 <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
//                   <div>
//                     {/* goes to table "propertyImages" as maptitle */}
//                     <textarea
//                       type="text"
//                       maxLength={50}
//                       value={maptitle}
//                       onChange={(e) => setmaptitle(e.target.value)}
//                       rows={2}
//                       className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       style={{
//                         letterSpacing: "1px",
//                         wordSpacing: "2px",
//                         lineHeight: 1.3,
//                       }}
//                       placeholder="Map Title"
//                     />
//                     <p className="text-xs block">
//                       {maptitle.length.toString().padStart(2, "0")}/50
//                     </p>
//                   </div>

//                   <div>
//                     {/* goes to table "propertyImages" as mapcontent */}
//                     <textarea
//                       type="text"
//                       maxLength={150}
//                       value={mapcontent}
//                       onChange={(e) => setmapcontent(e.target.value)}
//                       rows={4}
//                       className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       placeholder="Map Content..."
//                     />
//                     <p className="text-xs block">
//                       {mapcontent.length.toString().padStart(2, "0")}/150
//                     </p>
//                   </div>
//                 </div>
//                 {/* goes to table "properties" as maplang  */}
//                 <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Map Latitude (maplang)
//                     </label>
//                     <input
//                       type="number"
//                       step="0.00000001"
//                       name="maplang"
//                       value={maplang}
//                       onChange={(e) => setmaplang(e.target.value)}
//                       placeholder="Enter Latitude"
//                       className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     />
//                   </div>
//                   {/* goes to table "properties" as  maplong */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Map Longitude (maplong)
//                     </label>
//                     <input
//                       type="number"
//                       step="0.00000001"
//                       name="maplong"
//                       value={maplong}
//                       onChange={(e) => setmaplong(e.target.value)}
//                       placeholder="Enter Longitude"
//                       className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* Side StickyCard */}
//             <div className="lg:col-span-1 relative">
//               <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 pb-4 sticky top-10">
//                 <div className="mb-4">
//                   <div className="flex items-center text-4xl font-bold text-[#A23321]">
//                     ₹ {/* goes to table properties as currentprice */}
//                     <input
//                       type="text"
//                       value={bookingPrice}
//                       placeholder="Enter Current Price"
//                       onChange={(e) => setBookingPrice(e.target.value)}
//                       className="text-xl w-full bg-transparent border-b border-gray-300 focus:border-black focus:ring-0 px-1 py-0"
//                     />
//                   </div>
//                   <input
//                     type="text"
//                     value={bookingPriceDetails}
//                     onChange={(e) => setBookingPriceDetails(e.target.value)}
//                     className="text-base text-gray-400 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 px-1 py-0 mt-1"
//                   />
//                 </div>

//                 <div className="grid grid-cols-2 gap-4 mb-4">
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       Check-in ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
//                       <input
//                         type="date"
//                         value={bookingcheckinDate}
//                         onChange={(e) => setBookingcheckinDate(e.target.value)}
//                         className="text-base text-gray-800 font-medium w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0"
//                       />
//                       <input
//                         type="time"
//                         value={bookingcheckintime}
//                         onChange={(e) => setBookingcheckintime(e.target.value)}
//                         className="text-sm text-gray-500 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0 mt-1"
//                       />
//                     </div>
//                   </div>
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       Check-out ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
//                       <input
//                         type="date"
//                         value={bookingcheckoutDate}
//                         onChange={(e) => setBookingcheckoutDate(e.target.value)}
//                         className="text-base text-gray-800 font-medium w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0"
//                       />
//                       <input
//                         type="time"
//                         value={bookingcheckouttime}
//                         onChange={(e) => setBookingcheckouttime(e.target.value)}
//                         className="text-sm text-gray-500 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0 mt-1"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-2 gap-4 mb-6">
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       Guests ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
//                       <div className="flex items-center border-b border-gray-200 focus-within:border-black">
//                         {/* goes to table properties as maxadult */}
//                         <input
//                           type="number"
//                           value={bookingAdults}
//                           onChange={(e) => setBookingAdults(e.target.value)}
//                           className="text-base text-gray-800 font-medium w-8 bg-transparent border-none focus:ring-0 p-0"
//                         />
//                         <span className="text-base text-gray-800 font-medium ml-1">
//                           Adults,
//                         </span>
//                       </div>
//                       <div className="flex items-center border-b border-gray-200 mt-1 focus-within:border-black">
//                         {/* goes to table properties as maxchild */}
//                         <input
//                           type="number"
//                           value={bookingChildren}
//                           onChange={(e) => setBookingChildren(e.target.value)}
//                           className="text-base text-gray-800 font-medium w-8 bg-transparent border-none focus:ring-0 p-0"
//                         />
//                         <span className="text-base text-gray-800 font-medium ml-1">
//                           Children
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       No. of Rooms ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-3 text-center">
//                       <div className="flex items-center justify-center border-b border-gray-200 focus-within:border-black">
//                         {/* goes to table properties as maxbed
//                             Synced with "Max Bedroom" in the Required Data
//                             section above — same `bookingRooms` state. */}
//                         <input
//                           type="number"
//                           value={bookingRooms}
//                           onChange={(e) => setBookingRooms(e.target.value)}
//                           className="text-base text-gray-800 font-medium w-12 text-right bg-transparent border-none focus:ring-0 p-0"
//                         />
//                         <span className="text-base text-gray-800 font-medium ml-2">
//                           Rooms
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <hr className="border-gray-200 mb-4" />

//                 <div className="flex justify-between items-center mb-0">
//                   <p className="text-2xl font-bold text-gray-800">Total</p>
//                   <div className="text-right">
//                     <div className="flex items-center justify-end text-2xl font-bold text-[#A23321]">
//                       ₹{" "}
//                       <input
//                         type="text"
//                         value={bookingTotal}
//                         placeholder="Final Price"
//                         onChange={(e) => setBookingTotal(e.target.value)}
//                         className="w-32 text-xl text-right bg-transparent border-b border-gray-300 focus:border-black focus:ring-0 px-1 py-0"
//                       />
//                     </div>
//                     <p className="text-sm text-gray-400 mt-1">(Incl. taxes)</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Break */}
//           <div className="flex gap-3 items-center mx-5 md:mx-[5%] my-8 md:my-14 justify-center">
//             <div className="h-[1px] w-full bg-gray-300" />
//             <img
//               src="../assets/zorba_logo.webp"
//               alt="Img"
//               className="h-4 w-auto"
//             />
//             <div className="h-[1px] w-full bg-gray-300" />
//           </div>
//           {/* Break over  */}

//           {/* Tailored Experience */}
//           <div className="">
//             <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
//               <div>
//                 {/* goes to table "experiences" as "expnamemain" */}
//                 <input
//                   type="text"
//                   placeholder="Experience"
//                   maxLength={50}
//                   value={tailoredExperience}
//                   onChange={(e) => setTailoredExperience(e.target.value)}
//                   className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   style={{
//                     letterSpacing: "1px",
//                     wordSpacing: "2px",
//                     lineHeight: 1.3,
//                   }}
//                 />
//                 <p className="text-xs block mt-1">
//                   {tailoredExperience.length.toString().padStart(2, "0")}/50
//                 </p>

//                 {/* goes to table "experiences" as "expcontentmain" */}
//               </div>

//               <textarea
//                 type="text"
//                 rows={3}
//                 placeholder="Content..."
//                 value={tailoredExperienceContent}
//                 onChange={(e) => setTailoredExperienceContent(e.target.value)}
//                 maxLength={150}
//                 className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//               />
//               <p className="text-xs block">
//                 {tailoredExperienceContent.length.toString().padStart(2, "0")}
//                 /150
//               </p>
//             </div>

//             {/* Carousel of Tailored Experience */}
//             <div className="mt-5 -mx-3">
//               {/* goes to table "experiences" as "imagegrid1	, imagegrid2, imagegrid3 and imagegrid4" */}
//               <Carousel
//                 ref={carouselRef}
//                 responsive={responsive_TailoredExpCarousel}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
//                 customRightArrow={<CustomRightArrowTailoredExpCarousel />}
//                 beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
//               >
//                 {[...Array(MAX_CARDS_Exp)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="relative w-full h-[350px] bg-white border-2 border-dashed border-gray-400 overflow-hidden">
//                       {tailoredExpData[index]?.img ? (
//                         <>
//                           <img
//                             src={tailoredExpData[index].img}
//                             alt="Img"
//                             className="w-full h-full object-cover"
//                           />
//                           <div
//                             onClick={() => handleTailoredexpimageDelete(index)}
//                             className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
//                           >
//                             <MdDelete size={18} />
//                           </div>

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/webp"
//                               onChange={(e) => {
//                                 const file = e.target.files[0];
//                                 if (file) {
//                                   const newData = [...tailoredExpData];
//                                   newData[index].img =
//                                     URL.createObjectURL(file); // preview
//                                   newData[index].file = file; // actual File for backend
//                                   setTailoredExpData(newData);
//                                 }
//                               }}
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/webp"
//                             onChange={(e) => {
//                               const file = e.target.files[0];
//                               if (file) {
//                                 const newData = [...tailoredExpData];
//                                 newData[index].img = URL.createObjectURL(file);
//                                 newData[index].file = file;
//                                 setTailoredExpData(newData);
//                               }
//                             }}
//                             className="hidden"
//                           />
//                         </label>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>

//               <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
//                 <FaChevronLeft
//                   onClick={handlePrevSlide}
//                   className="cursor-pointer"
//                 />
//                 Showing {(activeCardIndex % TailoredExpCarousel.length) + 1} /
//                 {TailoredExpCarousel.length}
//                 <FaChevronRight
//                   onClick={handleNextSlide}
//                   className="cursor-pointer"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="mt-14 mb-5">
//           {submitError && (
//             <p className="text-red-600 text-sm mt-4">{submitError}</p>
//           )}

//           <div className="grid grid-cols-2 gap-3 mt-10 w-72 mx-auto">
//             <button
//               type="button"
//               onClick={() => navigate("/Properties")}
//               className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//             >
//               Cancel
//             </button>

//             <button
//               type="button"
//               onClick={handleSubmit}
//               disabled={isSubmitting}
//               className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {isSubmitting ? "Saving..." : "Save"}
//             </button>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default TestEditPropertyDetailElementor;
//=========================Design Skeleton for Edit Property Page=========================//
// import { useEffect, useRef, useState } from "react";
// import Menubar from "../Menubar/Menubar";
// import { Outlet } from "react-router-dom";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
// import { FaChevronRight } from "react-icons/fa6";
// import { FaChevronLeft } from "react-icons/fa6";
// import { FcAddImage } from "react-icons/fc";
// import { useNavigate } from "react-router-dom";
// import { Check } from "lucide-react";
// import { MdDelete } from "react-icons/md";

// const TestEditPropertyDetailElementor = () => {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   const navigate = useNavigate();

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const savedState = localStorage.getItem("menubarOpen");

//     if (savedState !== null) {
//       return JSON.parse(savedState);
//     }

//     return window.innerWidth >= 1024;
//   });
//   const [indiaStates, setIndiaStates] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [cities, setCities] = useState([]);

//   useEffect(() => {
//     // Load world.json from public folder
//     fetch("/world.json")
//       .then((res) => res.json())
//       .then((data) => {
//         const india = data.find((country) => country.name === "India");
//         if (india) {
//           setIndiaStates(india.states);
//         }
//       })
//       .catch((err) => console.error("Error loading world.json:", err));
//   }, []);

//   const handleStateChange = (e) => {
//     const stateName = e.target.value;
//     setSelectedState(stateName);

//     if (stateName.toLowerCase() === "goa") {
//       const goaCities = [
//         "Aldona",
//         "Arambol",
//         "Baga",
//         "Bambolim",
//         "Bandora",
//         "Benaulim",
//         "Calangute",
//         "Candolim",
//         "Carapur",
//         "Cavelossim",
//         "Chicalim",
//         "Chinchinim",
//         "Colovale",
//         "Colva",
//         "Cortalim",
//         "Cuncolim",
//         "Curchorem",
//         "Curti",
//         "Davorlim",
//         "Dicholi",
//         "Goa Velha",
//         "Guirim",
//         "Jua",
//         "Kankon",
//         "Madgaon",
//         "Мариса",
//         "Morjim",
//         "Mormugao",
//         "Navelim",
//         "North Goa",
//         "Palle",
//         "Panaji",
//         "Pernem",
//         "Ponda",
//         "Quepem",
//         "Queula",
//         "Raia",
//         "Saligao",
//         "Sancoale",
//         "Sanguem",
//         "Sanquelim",
//         "Sanvordem",
//         "Serula",
//         "Solim",
//         "South Goa",
//         "Taleigao",
//         "Vagator",
//         "Valpoy",
//         "Varca",
//         "Vasco da Gama",
//         // Extra villages
//         "Anjuna",
//         "Arpora",
//         "Assagao",
//         "Parra",
//         "Siolim",
//         "Reis Magos",
//         "Nerul",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(goaCities.map((city, idx) => ({ id: idx + 1, name: city })));
//     } else if (stateName.toLowerCase() === "karnataka") {
//       const karnatakaCities = [
//         // Extra villages

//         // Added cities
//         "Afzalpur",
//         "Ajjampur",
//         "Aland",
//         "Alnavar",
//         "lark",
//         "Alur",
//         "Anekal",
//         "Ankola",
//         "Annigeri",
//         "Arkalgud",
//         "Arsikere",
//         "Athni",
//         "Aurad",
//         "Badami",
//         "Bagalkot",
//         "Bagepalli",
//         "Bail-Hongal",
//         "Ballari",
//         "Banavar",
//         "Bangarapet",
//         "Bannur",
//         "Bantval",
//         "Basavakalyan",
//         "Basavana Bagevadi",
//         "Belagavi",
//         "Belluru",
//         "Beltangadi",
//         "Belur",
//         "Bengaluru",
//         "Bengaluru Rural",
//         "Bengaluru Urban",
//         "Bhadravati",
//         "Bhalki",
//         "Bhatkal",
//         "Bidar",
//         "Bilgi",
//         "Birur",
//         "Byadgi",
//         "Byndoor",
//         "Canacona",
//         "Challakere",
//         "Chamrajnagar",
//         "Channagiri",
//         "Channapatna",
//         "Channarayapatna",
//         "Chik Ballapur",
//         "Chikkaballapur",
//         "Chikkamagaluru",
//         "Chiknayakanhalli",
//         "Chikodi",
//         "Chincholi",
//         "Chintamani",
//         "Chitapur",
//         "Chitradurga",
//         "Closepet",
//         "Coondapoor",
//         "Coorg",
//         "Dakshina Kannada",
//         "Dandeli",
//         "Davanagere",
//         "Devanhalli",
//         "Dharwad",
//         "Dod Ballapur",
//         "French Rocks",
//         "Gadag",
//         "Gadag-Betageri",
//         "Gajendragarh",
//         "Gangawati",
//         "Gangolli",
//         "Gokak",
//         "Gokarna",
//         "Goribidnur",
//         "Gorur",
//         "Gubbi",
//         "Gudibanda",
//         "Guledagudda",
//         "Gundlupet",
//         "Gurmatkal",
//         "Hadagalli",
//         "Haliyal",
//         "Hampi",
//         "Hangal",
//         "Harihar",
//         "Harpanahalli",
//         "Hassan",
//         "Haveri",
//         "Heggadadevankote",
//         "Hirekerur",
//         "Hiriyur",
//         "Holalkere",
//         "Hole Narsipur",
//         "Homnabad",
//         "Honavar",
//         "Honnali",
//         "Hosanagara",
//         "Hosangadi",
//         "Hosdurga",
//         "Hoskote",
//         "Hospet",
//         "Hubballi",
//         "Hukeri",
//         "Hungund",
//         "Hunsur",
//         "Ilkal",
//         "Indi",
//         "Jagalur",
//         "Jamkhandi",
//         "Jevargi",
//         "Kabini",
//         "Kadur",
//         "Kalaburgi",
//         "Kalghatgi",
//         "Kampli",
//         "Kankanhalli",
//         "Karkala",
//         "Karwar",
//         "Kavalur",
//         "Kerur",
//         "Khanapur",
//         "Kodagu",
//         "Kodigenahalli",
//         "Kodlipet",
//         "Kolar",
//         "Kollegal",
//         "Konanur",
//         "Konnur",
//         "Koppa",
//         "Koppal",
//         "Koratagere",
//         "Kotturu",
//         "Krishnarajpet",
//         "Kudachi",
//         "Kudligi",
//         "Kumsi",
//         "Kumta",
//         "Kundgol",
//         "Kunigal",
//         "Kurgunta",
//         "Kushalnagar",
//         "Kushtagi",
//         "Lakshmeshwar",
//         "Lingsugur",
//         "Londa",
//         "Machare",
//         "Maddagiri",
//         "Maddur",
//         "Madikeri",
//         "Magadi",
//         "Mahalingpur",
//         "Malavalli",
//         "Malpe",
//         "Malur",
//         "Mandya",
//         "Mangaluru",
//         "Manipal",
//         "Manvi",
//         "Mayakonda",
//         "Melukote",
//         "Mudbidri",
//         "Muddebihal",
//         "Mudgal",
//         "Mudgere",
//         "Mudhol",
//         "Mulbagal",
//         "Mulgund",
//         "Mulki",
//         "Mundargi",
//         "Mundgod",
//         "Munirabad",
//         "Murudeshwara",
//         "Mysuru",
//         "Nagamangala",
//         "Nanjangud",
//         "Narasimharajapura",
//         "Naregal",
//         "Nargund",
//         "Navalgund",
//         "Nelamangala",
//         "Nyamti",
//         "Pangala",
//         "Pavugada",
//         "Piriyapatna",
//         "Ponnampet",
//         "Puttur",
//         "Rabkavi",
//         "Raichur",
//         "Ramanagara",
//         "Ranibennur",
//         "Raybag",
//         "Robertsonpet",
//         "Ron",
//         "Sadalgi",
//         "Sagar",
//         "Sakleshpur",
//         "Sandur",
//         "Sanivarsante",
//         "Sankeshwar",
//         "Sargur",
//         "Saundatti",
//         "Savanur",
//         "Seram",
//         "Shahabad",
//         "Shahpur",
//         "Shiggaon",
//         "Shikarpur",
//         "Shimoga",
//         "Shirhatti",
//         "Shorapur",
//         "Shrirangapattana",
//         "Siddapur",
//         "Sidlaghatta",
//         "Sindgi",
//         "Sindhnur",
//         "Sira",
//         "Sirsi",
//         "Siruguppa",
//         "Someshwar",
//         "Somvarpet",
//         "Sorab",
//         "Sravana Belgola",
//         "Sringeri",
//         "Srinivaspur",
//         "Sulya",
//         "Suntikoppa",
//         "Talikota",
//         "Tarikere",
//         "Tekkalakote",
//         "Terdal",
//         "Tiptur",
//         "Tirthahalli",
//         "Tirumakudal Narsipur",
//         "Tumakuru",
//         "Turuvekere",
//         "Udupi",
//         "Ullal",
//         "Uttar Kannada",
//         "Vadigenhalli",
//         "Vijayapura",
//         "Virarajendrapet",
//         "Wadi",
//         "Yadgir",
//         "Yelahanka",
//         "Yelandur",
//         "Yelbarga",
//         "Yellapur",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(
//         karnatakaCities.map((city, idx) => ({ id: idx + 1, name: city })),
//       );
//     } else if (stateName.toLowerCase() === "kerala") {
//       const keralaCities = [
//         "Adoor",
//         "Alappuzha",
//         "Alleppey",
//         "Aluva",
//         "Alwaye",
//         "Angamali",
//         "Aroor",
//         "Arukutti",
//         "Attingal",
//         "Avanoor",
//         "Azhikkal",
//         "Beypore",
//         "Changanacheri",
//         "Chelakara",
//         "Chengannur",
//         "Cherpulassery",
//         "Cherthala",
//         "Chetwayi",
//         "Chittur",
//         "Cochin",
//         "Dharmadom",
//         "Edakkulam",
//         "Elur",
//         "Erattupetta",
//         "Ernakulam",
//         "Ferokh",
//         "Guruvayur",
//         "Idukki",
//         "Iringal",
//         "Irinjalakuda",
//         "Kadakkavoor",
//         "Kalamassery",
//         "Kalavoor",
//         "Kalpetta",
//         "Kanhangad",
//         "Kannavam",
//         "Kannur",
//         "Kasaragod",
//         "Kattanam",
//         "Kayankulam",
//         "Kizhake Chalakudi",
//         "Kochi",
//         "Kodungallur",
//         "Kollam",
//         "Kotamangalam",
//         "Kottayam",
//         "Kovalam",
//         "Kozhikode",
//         "Kumbalam",
//         "Kunnamangalam",
//         "Kunnamkulam",
//         "Kunnumma",
//         "Kutiatodu",
//         "Kuttampuzha",
//         "Lalam",
//         "Mahe",
//         "Malappuram",
//         "Manjeri",
//         "Manjeshwaram",
//         "Mannarakkat",
//         "Marayur",
//         "Mattanur",
//         "Mavelikara",
//         "Mavoor",
//         "Muluppilagadu",
//         "Munnar",
//         "Muvattupula",
//         "Muvattupuzha",
//         "Nadapuram",
//         "Naduvannur",
//         "Nedumangad",
//         "Neyyattinkara",
//         "Nileshwar",
//         "Ottappalam",
//         "Palackattumala",
//         "Palakkad district",
//         "Palghat",
//         "Panamaram",
//         "Pappinissheri",
//         "Paravur Tekkumbhagam",
//         "Pariyapuram",
//         "Pathanamthitta",
//         "Pattanamtitta",
//         "Payyanur",
//         "Perinthalmanna",
//         "Perumbavoor",
//         "Perumpavur",
//         "Perya",
//         "Piravam",
//         "Ponnani",
//         "Ponmana",
//         "Punalur",
//         "Punnayur",
//         "Ramamangalam",
//         "Shertallai",
//         "Shoranur",
//         "Taliparamba",
//         "Thalassery",
//         "Thalikulam",
//         "Thanniyam",
//         "Thekkady",
//         "Thiruvananthapuram",
//         "Thrissur",
//         "Tirur",
//         "Tiruvalla",
//         "Vaikam",
//         "Varkala",
//         "Vatakara",
//         "Vayalar",
//         "Vettur",
//         "Wayanad",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(keralaCities.map((city, idx) => ({ id: idx + 1, name: city })));
//     } else if (stateName.toLowerCase() === "tamil nadu") {
//       const tamilnaduCities = [
//         // Tamil Nadu cities
//         "Aambur",
//         "Ariyalur",
//         "Arakkonam",
//         "Arani",
//         "Attur",
//         "Avadi",
//         "Batlagundu",
//         "Chengalpattu",
//         "Chennai",
//         "Chidambaram",
//         "Coimbatore",
//         "Courtallam",
//         "Cuddalore",
//         "Coonoor",
//         "Dharapuram",
//         "Dharmapuri",
//         "Dindigul",
//         "Erode",
//         "Gobichettipalayam",
//         "Gudalur",
//         "Gudiyatham",
//         "Hosur",
//         "Jayankondam",
//         "Kallakurichi",
//         "Kanchipuram",
//         "Kanyakumari",
//         "Karaikudi",
//         "Karur",
//         "Kodaikanal",
//         "Kovilpatti",
//         "Krishnagiri",
//         "Kumbakonam",
//         "Madurai",
//         "Manapparai",
//         "Mahabalipuram",
//         "Mayiladuthurai",
//         "Mettupalayam",
//         "Namakkal",
//         "Nagapattinam",
//         "Nagercoil",
//         "Ooty",
//         "Palani",
//         "Pallavaram",
//         "Pattukkottai",
//         "Perambalur",
//         "Pollachi",
//         "Poonamallee",
//         "Pudukkottai",
//         "Rajapalayam",
//         "Ramanathapuram",
//         "Ranipet",
//         "Salem",
//         "Sankagiri",
//         "Sivaganga",
//         "Sivakasi",
//         "Tambaram",
//         "Tenkasi",
//         "Thanjavur",
//         "Theni",
//         "Thiruvallur",
//         "Thiruvarur",
//         "Thoothukudi",
//         "Tindivanam",
//         "Tiruchendur",
//         "Tiruchengode",
//         "Tiruchirappalli",
//         "Tirunelveli",
//         "Tirupathur",
//         "Tiruppur",
//         "Tiruvannamalai",
//         "Udagamandalam",
//         "Udumalpet",
//         "Usilampatti",
//         "Vaniyambadi",
//         "Vellore",
//         "Villupuram",
//         "Virudhunagar",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(
//         tamilnaduCities.map((city, idx) => ({ id: idx + 1, name: city })),
//       );
//     } else {
//       const stateObj = indiaStates.find((s) => s.name === stateName);
//       setCities(stateObj ? stateObj.cities : []);
//     }
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);

//       if (mobile) {
//         setIsSidebarOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const MAX_CARDS = 25;

//   const [selectedImages, setSelectedImages] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   // Category assigned to each banner slide/image (parallel array to selectedImages)
//   const [selectedCategories, setSelectedCategories] = useState(
//     Array(MAX_CARDS).fill(""),
//   );

//   const [activeBannerIndex, setActiveBannerIndex] = useState(0);
//   const [bannerCategoryError, setBannerCategoryError] = useState("");
//   const [showGalleryModal, setShowGalleryModal] = useState(false);
//   const bannerCarouselRef = useRef(null);

//   // Checks whether the slide at `index` is blocking navigation
//   // (i.e. it has an uploaded/selected image but no category chosen yet)
//   const isBannerSlideBlocked = (index) => {
//     return !!selectedImages[index] && !selectedCategories[index];
//   };

//   const CustomLeftArrowBannerCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowBannerCarousel = ({ onClick }) => {
//     const handleNextClick = () => {
//       // Block moving to the next slide until the current slide's image has a category
//       if (isBannerSlideBlocked(activeBannerIndex)) {
//         setBannerCategoryError(
//           "Please select a category for this image before moving to the next slide.",
//         );
//         return;
//       }
//       setBannerCategoryError("");
//       onClick();
//     };

//     return (
//       <button
//         onClick={handleNextClick}
//         className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   // Plain arrows (no category validation) — used by carousels other than the
//   // main banner (e.g. the per-bedroom image carousels below), so they don't
//   // accidentally inherit the banner's category-gate logic.
//   const CustomLeftArrowPlain = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowPlain = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   // Guards against the corrective goToSlide (below) re-triggering this same
//   // handler and causing an oscillation/"stuck" loop.
//   const isCorrectingBannerSlideRef = useRef(false);

//   // Safety net for navigation that bypasses the arrow buttons (swipe, keyboard, dots):
//   // if the previous slide had an image without a category, snap back to it —
//   // but ONLY when moving forward. Moving backward must always be allowed,
//   // otherwise a later incomplete slide permanently blocks the user from ever
//   // navigating back to fix it.
//   const handleBannerAfterChange = (previousSlide, { currentSlide }) => {
//     if (isCorrectingBannerSlideRef.current) {
//       isCorrectingBannerSlideRef.current = false;
//       setActiveBannerIndex(currentSlide);
//       return;
//     }

//     const movingForward = currentSlide > previousSlide;

//     if (movingForward && isBannerSlideBlocked(previousSlide)) {
//       setBannerCategoryError(
//         "Please select a category for this image before moving to the next slide.",
//       );
//       isCorrectingBannerSlideRef.current = true;
//       if (bannerCarouselRef.current) {
//         bannerCarouselRef.current.goToSlide(previousSlide);
//       }
//       setActiveBannerIndex(previousSlide);
//       return;
//     }
//     setBannerCategoryError("");
//     setActiveBannerIndex(currentSlide);
//   };

//   const handleImageUpload = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...selectedImages];
//       // position is index + 1 -> row in `allPropertyImages`
//       updatedImages[index] = { url: imageurl, file };
//       setSelectedImages(updatedImages);
//     }
//   };

//   const handleBannerImageDelete = (index) => {
//     setSelectedImages((prev) => {
//       const u = [...prev];
//       u[index] = null;
//       return u;
//     });
//     // Clear the category assignment along with the image
//     setSelectedCategories((prev) => {
//       const u = [...prev];
//       u[index] = "";
//       return u;
//     });
//     setBannerCategoryError("");
//   };

//   const handleBannerCategoryChange = (index, categoryValue) => {
//     setSelectedCategories((prev) => {
//       const u = [...prev];
//       u[index] = categoryValue;
//       return u;
//     });
//     if (categoryValue) {
//       setBannerCategoryError("");
//     }
//   };

//   // Builds the ordered category list, with Bedroom/Bathroom expanded dynamically
//   // based on the "No. of Rooms" (bookingRooms/maxbed) and "Max Bathroom" (maxbath) inputs.
//   const getBannerCategoryOptions = () => {
//     const bedroomCount = parseInt(bookingRooms) || 0;
//     const bathroomCount = parseInt(maxbath) || 0;

//     const bedroomOptions =
//       bedroomCount > 0
//         ? Array.from({ length: bedroomCount }, (_, i) => `Bedroom ${i + 1}`)
//         : ["Bedroom"];

//     const bathroomOptions =
//       bathroomCount > 0
//         ? Array.from({ length: bathroomCount }, (_, i) => `Bathroom ${i + 1}`)
//         : ["Bathroom"];

//     return [
//       "Living Room",
//       "Dining Area",
//       ...bedroomOptions,
//       ...bathroomOptions,
//       "Pool",
//       "Courtyard",
//       "Games & Activity Area",
//       "Exterior",
//       "Jacuzzi",
//       "Theatre Room",
//       "Gym",
//       "Garden",
//       "Kitchen",
//       "Additional Photos",
//     ];
//   };

//   // Groups every selected banner image by its assigned category, for the "View All" gallery.
//   // Categories with no images are omitted.
//   const getGroupedBannerGallery = () => {
//     const grouped = {};
//     getBannerCategoryOptions().forEach((cat) => {
//       grouped[cat] = [];
//     });
//     selectedImages.forEach((img, index) => {
//       const cat = selectedCategories[index];
//       if (img && cat) {
//         if (!grouped[cat]) grouped[cat] = [];
//         grouped[cat].push({ ...img, index });
//       }
//     });
//     return Object.entries(grouped).filter(([, imgs]) => imgs.length > 0);
//   };

//   // Pulls the images assigned to a given bedroom directly from the banner's
//   // selectedImages/selectedCategories (category === "Bedroom {roomIndex + 1}").
//   // This keeps the Bedroom Carousel section below in sync with the banner —
//   // there is no separate upload step here anymore.
//   const getBedroomImages = (roomIndex) => {
//     const categoryLabel = `Bedroom ${roomIndex + 1}`;
//     const images = [];
//     selectedImages.forEach((img, idx) => {
//       if (img && selectedCategories[idx] === categoryLabel) {
//         images.push({ ...img, bannerIndex: idx });
//       }
//     });
//     return images;
//   };

//   const TailoredExpCarousel = [
//     {
//       img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/77613/villa-barbados-caribbean-luxury-the-great-house-boat_FullL.jpg?v=302558110212",
//       title: "For Adventure Seekers",
//       content:
//         "Experience the thrill of Goa with our adventure package! Enjoy cozy stays, a hearty breakfast, and activities like water sports, trekking, and more.",
//     },
//     {
//       img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/66699/villa-barbados-caribbean-luxury-the-great-house-ext-9_FullL.jpg?v=302558110212",
//       title: "For Leisure Lovers",
//       content:
//         "Unwind with our leisure package in Goa. Relax in serene stays, savor a delicious breakfast, and enjoy peaceful beaches, spa sessions, and local attractions.",
//     },
//   ];

//   const responsive_TailoredExpCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_OuterCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 3,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 3,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_BannerCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const [showDots, setShowDots] = useState(false);

//   useEffect(() => {
//     const updateDotsVisibility = () => {
//       setShowDots(window.innerWidth < 768);
//     };

//     updateDotsVisibility();
//     window.addEventListener("resize", updateDotsVisibility);
//     return () => window.removeEventListener("resize", updateDotsVisibility);
//   }, []);

//   const responsive_ImageCarouselOne = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const CustomLeftArrowTailoredExpCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-44 transform -translate-y-1/2 shadow-custom bg-white bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowTailoredExpCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute right-3 top-44 transform -translate-y-1/2 shadow-custom bg-white bg-opacity-90 hover:bg-opacity-100 text-sm hover:text-green-600 rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   const [activeCardIndex, setActiveCardIndex] = useState(0);
//   const carouselRef = useRef(null);

//   const handlePrevSlide = () => {
//     if (carouselRef.current) {
//       carouselRef.current.previous();
//     }
//   };

//   const handleNextSlide = () => {
//     if (carouselRef.current) {
//       carouselRef.current.next();
//     }
//   };

//   const [, setIsOpen_dropdownExp] = useState(false);
//   const dropdownRef_dropdownExp = useRef(null);

//   useEffect(() => {
//     const handleClickOutside_dropdownExp = (event) => {
//       if (
//         dropdownRef_dropdownExp.current &&
//         !dropdownRef_dropdownExp.current.contains(event.target)
//       ) {
//         setIsOpen_dropdownExp(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside_dropdownExp);
//     return () =>
//       document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
//   }, []);
//   const [tailoredExpData, setTailoredExpData] = useState([
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//   ]);
//   const MAX_CARDS_Exp = tailoredExpData.length;

//   // Booking Widget States
//   const [bookingPrice, setBookingPrice] = useState("");
//   const [bookingPriceDetails, setBookingPriceDetails] = useState(
//     "(for 10 rooms) Per Night + Taxes",
//   );
//   const [bookingcheckinDate, setBookingcheckinDate] = useState("");
//   const [bookingcheckintime, setBookingcheckintime] = useState("");
//   const [bookingcheckoutDate, setBookingcheckoutDate] = useState("");
//   const [bookingcheckouttime, setBookingcheckouttime] = useState("");
//   const [bookingAdults, setBookingAdults] = useState("2");
//   const [bookingChildren, setBookingChildren] = useState("0");
//   const [bookingRooms, setBookingRooms] = useState("3");
//   const [bookingTotal, setBookingTotal] = useState("");

//   const [propertyname, setpropertyname] = useState("");
//   const [description, setDescription] = useState("");
//   const [heading, setHeading] = useState("");
//   const [content, setContent] = useState("");
//   const [catchyQuote, setCatchyQuote] = useState("");
//   const [maptitle, setmaptitle] = useState("");
//   const [mapcontent, setmapcontent] = useState("");
//   const [tailoredExperience, setTailoredExperience] = useState("");
//   const [tailoredExperienceContent, setTailoredExperienceContent] =
//     useState("");

//   const [maplang, setmaplang] = useState("");
//   const [maplong, setmaplong] = useState("");

//   // Additional required data (not shown on website)
//   const [propertycode, setpropertycode] = useState("");
//   const [propertyowner, setpropertyowner] = useState("");
//   const [airid, setairid] = useState("");
//   const [instagramreellink, setinstagramreellink] = useState("");
//   const [propertyBrochure, setPropertyBrochure] = useState("");
//   const [defaultprice, setdefaultprice] = useState("");
//   const [deposit, setDeposit] = useState("");
//   const [maxbath, setmaxbath] = useState("");
//   const [maplink, setMaplink] = useState("");
//   const [youtubelink, setYoutubelink] = useState("");
//   const [seasonType, setSeasonType] = useState("");
//   const [propertytype, setpropertytype] = useState("Villa");
//   const [location, setLocation] = useState("");
//   const [rating, setRating] = useState("");

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState("");

//   const [amenitiesList, setAmenitiesList] = useState([]);
//   const [selectedAmenities, setSelectedAmenities] = useState([]); // stores ids: [1, 4, 5]

//   const [searchTerm, setSearchTerm] = useState("");
//   const [isOpen_amenities, setIsOpen_amenities] = useState(false);

//   useEffect(() => {
//     // Mock amenities
//     setAmenitiesList([
//       { id: 1, name: "WiFi" },
//       { id: 2, name: "Swimming Pool" },
//       { id: 3, name: "Air Conditioning" },
//       { id: 4, name: "Kitchen" },
//       { id: 5, name: "Free Parking" },
//     ]);
//   }, []);

//   // Toggle stores/removes the numeric id
//   const toggleAmenity = (id) => {
//     setSelectedAmenities((prev) =>
//       prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id],
//     );
//   };

//   const filteredAmenities = amenitiesList.filter((amenity) =>
//     amenity.name.toLowerCase().includes(searchTerm.toLowerCase()),
//   );

//   const containerRef_amenities = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         containerRef_amenities.current &&
//         !containerRef_amenities.current.contains(event.target)
//       ) {
//         setIsOpen_amenities(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleSubmit = async () => {
//     setSubmitError("");

//     if (
//       !propertyname ||
//       !propertycode ||
//       !propertytype ||
//       !selectedState ||
//       !location
//     ) {
//       setSubmitError("Please fill all required (*) fields before saving.");
//       return;
//     }

//     const uncategorizedBannerIndex = selectedImages.findIndex(
//       (img, index) => img && !selectedCategories[index],
//     );
//     if (uncategorizedBannerIndex !== -1) {
//       setSubmitError(
//         `Please select a category for banner slide ${uncategorizedBannerIndex + 1} before saving.`,
//       );
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const formData = new FormData();

//       // ── Simple text fields -> `properties` table ──
//       formData.append("propertyname", propertyname);
//       formData.append("description", description);
//       formData.append("heading", heading);
//       formData.append("content", content);
//       formData.append("catchquote", catchyQuote);
//       formData.append("maplang", maplang);
//       formData.append("maplong", maplong);
//       formData.append("propertycode", propertycode);
//       formData.append("propertyowner", propertyowner);
//       formData.append("airid", airid);
//       formData.append("instagramreellink", instagramreellink);
//       formData.append("propertyBrochure", propertyBrochure);
//       formData.append("currentprice", bookingPrice);
//       formData.append("defaultprice", defaultprice);
//       formData.append("deposit", deposit);
//       formData.append("maxadult", bookingAdults);
//       formData.append("maxchild", bookingChildren);
//       formData.append("maxbed", bookingRooms);
//       formData.append("maxbath", maxbath);
//       formData.append("maplink", maplink);
//       formData.append("youtubelink", youtubelink);
//       formData.append("seasonType", seasonType);
//       formData.append("propertytype", propertytype);
//       formData.append("destination", selectedState);
//       formData.append("location", location);

//       // ── Map / propertyImages text fields ──
//       formData.append("maptitle", maptitle);
//       formData.append("mapcontent", mapcontent);

//       // ── Amenities (ids) ──
//       formData.append("amenities", JSON.stringify(selectedAmenities));

//       // ── Tailored experience ──
//       formData.append("expnamemain", tailoredExperience);
//       formData.append("expcontentmain", tailoredExperienceContent);

//       // ── Banner images -> `allPropertyImages` (fieldname carries position) ──
//       // Each image is stored together with its assigned category.
//       selectedImages.forEach((img, index) => {
//         if (img?.file) {
//           formData.append(`banner_${index + 1}`, img.file);
//           formData.append(
//             `banner_${index + 1}_category`,
//             selectedCategories[index] || "",
//           );
//         }
//       });

//       // ── Bedroom images -> `allPropertyBedrooms` + `allPropertyBedroomImages` ──
//       // fieldname pattern: bedroom_<roomPosition>_<imagePosition>
//       // Sourced directly from the banner images grouped by "Bedroom N" category.
//       const bedroomCountForSubmit = parseInt(bookingRooms) || 1;
//       for (let roomIndex = 0; roomIndex < bedroomCountForSubmit; roomIndex++) {
//         getBedroomImages(roomIndex).forEach((img, imgIndex) => {
//           if (img?.file) {
//             formData.append(
//               `bedroom_${roomIndex + 1}_${imgIndex + 1}`,
//               img.file,
//             );
//           }
//         });
//       }

//       // ── Tailored experience images -> `experiences` (imagegrid1..4) ──
//       tailoredExpData.forEach((exp, index) => {
//         if (exp?.file) {
//           formData.append(`expimage${index + 1}`, exp.file);
//         }
//       });

//       // Simulate backend save
//       setTimeout(() => {
//         console.log("Form data saved:", Object.fromEntries(formData));
//         setIsSubmitting(false);
//         navigate("/Properties");
//       }, 1000);
//     } catch (err) {
//       console.error("Error saving property:", err);
//       setSubmitError(err.message || "Something went wrong while saving.");
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div
//       className={`flex bg-[#F8F9FA] transition-all duration-500 ${
//         isMobile ? "ml-0" : isSidebarOpen ? "w-[82vw]" : "w-[95vw]"
//       }`}
//     >
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${
//           isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
//         }`}
//       >
//         <Outlet />

//         {/* Header */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
//             <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//               Add New Property
//             </p>
//           </div>
//         </div>

//         {/* Data not to be shown in website */}
//         <div className="mt-10">
//           <p className="text-lg text-center mb-6">
//             Required Data <i>(not to be displayed on the website)</i>
//           </p>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5">
//             <div className="flex flex-col w-full">
//               {/* goes to table properties as propertycode */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property Code <sub className="text-red-500 text-base">*</sub>
//               </label>
//               <input
//                 placeholder="Enter property code"
//                 name="propertycode"
//                 required
//                 value={propertycode}
//                 onChange={(e) => setpropertycode(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as propertyowner */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property's Owner name
//               </label>
//               <input
//                 placeholder="Enter Owner's name"
//                 name="propertyowner"
//                 value={propertyowner}
//                 onChange={(e) => setpropertyowner(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>
//             <div className="flex flex-col w-full">
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property ID
//               </label>
//               <input
//                 placeholder="Enter Airbnb ID"
//                 name="airid"
//                 value={airid}
//                 onChange={(e) => setairid(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>
//             <div className="flex flex-col w-full">
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Instagram Reel Link
//               </label>
//               <input
//                 placeholder="Enter Instagram Reel Link"
//                 name="instagramreellink"
//                 value={instagramreellink}
//                 onChange={(e) => setinstagramreellink(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>
//             <div className="flex flex-col w-full">
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Property Brochure
//               </label>
//               <input
//                 placeholder="Enter Drive Link"
//                 name="propertyBrochure"
//                 value={propertyBrochure}
//                 onChange={(e) => setPropertyBrochure(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as defaultprice */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Default Price
//               </label>
//               <input
//                 placeholder="Enter default price"
//                 name="defaultprice"
//                 value={defaultprice}
//                 onChange={(e) => setdefaultprice(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as deposit */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Security Deposit
//               </label>
//               <input
//                 placeholder="Enter security deposit"
//                 name="deposit"
//                 value={deposit}
//                 onChange={(e) => setDeposit(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxadult
//                   Synced with "Guests" (Adults) in the Booking Widget below —
//                   both read/write the same `bookingAdults` state. */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Adults
//               </label>
//               <input
//                 type="number"
//                 placeholder="Enter max adults"
//                 name="maxadult"
//                 value={bookingAdults}
//                 onChange={(e) => setBookingAdults(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxchild
//                   Synced with "Guests" (Children) in the Booking Widget below —
//                   both read/write the same `bookingChildren` state. */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Children
//               </label>
//               <input
//                 type="number"
//                 placeholder="Enter max children"
//                 name="maxchild"
//                 value={bookingChildren}
//                 onChange={(e) => setBookingChildren(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxbed
//                   Synced with "No. of Rooms" in the Booking Widget below —
//                   both read/write the same `bookingRooms` state, so changing
//                   either one updates the other automatically. */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Bedroom
//               </label>
//               <input
//                 type="number"
//                 placeholder="Enter max bedroom"
//                 name="maxbed"
//                 value={bookingRooms}
//                 onChange={(e) => setBookingRooms(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maxbath */}

//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Max Bathroom
//               </label>
//               <input
//                 placeholder="Enter max bathroom"
//                 name="maxbath"
//                 value={maxbath}
//                 onChange={(e) => setmaxbath(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as maplink */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Map Location
//               </label>
//               <input
//                 placeholder="Enter map location"
//                 name="maplink"
//                 value={maplink}
//                 onChange={(e) => setMaplink(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as youtubelink */}
//               <label
//                 for="input"
//                 className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//               >
//                 Youtube Link
//               </label>
//               <input
//                 placeholder="Enter youtube link"
//                 name="youtubelink"
//                 value={youtubelink}
//                 onChange={(e) => setYoutubelink(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               />
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as seasonType */}
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Season Type
//               </label>

//               <select
//                 name="seasonType"
//                 value={seasonType}
//                 onChange={(e) => setSeasonType(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="">Select season type</option>
//                 <option value="Summer">Summer</option>
//                 <option value="Winter">Winter</option>
//                 <option value="Monsoon">Monsoon</option>
//               </select>
//             </div>

//             <div className="flex flex-col w-full">
//               {/* goes to table properties as propertytype */}
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Property Type<sub className="text-red-500 text-base">*</sub>
//               </label>

//               <select
//                 name="propertytype"
//                 required
//                 value={propertytype}
//                 onChange={(e) => setpropertytype(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="Villa">Villa</option>
//               </select>
//             </div>

//             {/* Destination (State) */}
//             <div className="flex flex-col w-full">
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Destination<sub className="text-red-500 text-base">*</sub>
//               </label>
//               <select
//                 name="destination"
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 value={selectedState}
//                 onChange={handleStateChange}
//                 required
//               >
//                 <option value="">Select your destination</option>
//                 {indiaStates.map((state) => (
//                   <option key={state.id} value={state.name}>
//                     {state.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Location (City) */}
//             <div className="flex flex-col w-full">
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Select Location <sub className="text-red-500 text-base">*</sub>
//               </label>
//               <select
//                 name="location"
//                 required
//                 value={location}
//                 onChange={(e) => setLocation(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="">Select your location</option>
//                 {cities.map((city) => (
//                   <option key={city.id} value={city.name}>
//                     {city.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="flex flex-col w-full">
//               <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                 Property Rating
//               </label>

//               <select
//                 name="rating"
//                 required
//                 value={rating}
//                 onChange={(e) => setRating(e.target.value)}
//                 className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//               >
//                 <option value="">Enter Rating</option>
//                 <option value="5">5</option>
//                 <option value="4">4</option>
//                 <option value="3">3</option>
//                 <option value="2">2</option>
//                 <option value="1">1</option>
//                 <option value="0">0</option>
//               </select>
//             </div>
//           </div>
//         </div>

//         <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-10 md:my-16 justify-center">
//           <div className="h-[1px] w-full bg-gray-300" />
//           <img
//             src="../assets/zorba_logo.webp"
//             alt="Img"
//             className="h-4 w-auto"
//           />
//           <div className="h-[1px] w-full bg-gray-300" />
//         </div>

//         <div className="my-10">
//           <div className="">
//             <div className="flex flex-col items-center justify-center w-full max-w-3xl mx-auto text-center mt-8">
//               <div className="w-full">
//                 {/* goes to table "properties" as "propertyname" */}
//                 <input
//                   type="text"
//                   name="propertyname"
//                   required
//                   maxLength={50}
//                   value={propertyname}
//                   onChange={(e) => setpropertyname(e.target.value)}
//                   className="w-full text-center text-2xl sm:text-3xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Enter Property Name"
//                 />
//                 <p className="text-xs mt-1 text-center">
//                   {propertyname.length.toString().padStart(2, "0")}/50
//                 </p>
//                 {/* goes to table "properties" as "description" */}
//                 <div className="my-4">
//                   <textarea
//                     rows="2"
//                     name="description"
//                     maxLength={250}
//                     value={description}
//                     onChange={(e) => setDescription(e.target.value)}
//                     className="w-full text-center text-gray-700 text-lg border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     placeholder="Enter Property Description..."
//                   />
//                   <p className="text-xs text-center">
//                     {description.length.toString().padStart(2, "0")}/250
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Banner carousel */}
//             <div className="mt-5 -mx-3 relative">
//               {/* Images are stored in the `allPropertyImages` table with:
//     propertyid, imageurl, and position (1, 2, 3, ...)
// */}

//               <Carousel
//                 ref={bannerCarouselRef}
//                 responsive={responsive_BannerCarousel}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite={false}
//                 keyBoardControl
//                 showDots={false}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//                 afterChange={handleBannerAfterChange}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[58vh] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {selectedImages[index] ? (
//                         <>
//                           <img
//                             src={selectedImages[index]?.url}
//                             alt="Img"
//                             className="w-full h-full object-cover"
//                           />

//                           <div
//                             onClick={() => handleBannerImageDelete(index)}
//                             className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
//                           >
//                             <MdDelete size={18} />
//                           </div>

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/webp"
//                               onChange={(e) => handleImageUpload(e, index)}
//                               className="hidden"
//                             />
//                           </label>

//                           {/* Per-slide category dropdown (mandatory once this slide has an image) */}
//                           <div className="absolute bottom-2 right-24 z-10 flex flex-col items-end">
//                             <select
//                               name={`bannerCategory_${index}`}
//                               value={selectedCategories[index] || ""}
//                               onChange={(e) =>
//                                 handleBannerCategoryChange(
//                                   index,
//                                   e.target.value,
//                                 )
//                               }
//                               className={`text-xs font-medium rounded-md px-2 py-1.5 max-w-[150px] focus:outline-none focus:ring-0 shadow-sm ${
//                                 selectedCategories[index]
//                                   ? "bg-white/90 border border-gray-300 text-gray-800"
//                                   : "bg-red-50/95 border border-red-500 text-red-700"
//                               }`}
//                             >
//                               <option value="">Select category*</option>
//                               {getBannerCategoryOptions().map((cat) => (
//                                 <option key={cat} value={cat}>
//                                   {cat}
//                                 </option>
//                               ))}
//                             </select>
//                           </div>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/webp"
//                             onChange={(e) => handleImageUpload(e, index)}
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       <div className="absolute top-1 left-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>

//               {/* View All button, pinned to the banner's bottom-right corner (stays put while slides change) */}
//               <button
//                 type="button"
//                 onClick={() => setShowGalleryModal(true)}
//                 className="absolute z-20 bottom-2.5 right-6 px-4 py-[7.5px] bg-green-800 hover:bg-green-700 rounded-md text-white text-xs font-medium shadow-sm transition-colors"
//               >
//                 View All
//               </button>

//               {bannerCategoryError && (
//                 <p className="absolute z-20 bottom-14 right-3 bg-red-600 text-white text-xs px-3 py-1.5 rounded shadow-sm max-w-xs text-right">
//                   {bannerCategoryError}
//                 </p>
//               )}
//             </div>
//           </div>

//           {/* View All Gallery Modal */}
//           {showGalleryModal && (
//             <div
//               className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
//               onClick={() => setShowGalleryModal(false)}
//             >
//               <div
//                 className="bg-white rounded-xl w-full max-w-5xl max-h-[85vh] overflow-y-auto pt-0 p-6 relative"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <button
//                   type="button"
//                   onClick={() => setShowGalleryModal(false)}
//                   className="sticky top-3 ml-auto block z-50 text-gray-500 hover:text-black text-xl font-semibold px-2"
//                 >
//                   ✕
//                 </button>

//                 {getGroupedBannerGallery().length === 0 ? (
//                   <p className="text-gray-500 text-sm">
//                     No images have been assigned a category yet.
//                   </p>
//                 ) : (
//                   getGroupedBannerGallery().map(([category, images]) => (
//                     <div key={category} className="mb-8">
//                       <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b border-gray-100 pb-2">
//                         {category}{" "}
//                         <span className="text-sm font-normal text-gray-400">
//                           ({images.length})
//                         </span>
//                       </h3>
//                       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
//                         {images.map((img) => (
//                           <div
//                             key={img.index}
//                             className="aspect-square rounded-lg overflow-hidden border border-gray-200"
//                           >
//                             <img
//                               src={img.url}
//                               alt={category}
//                               className="w-full h-full object-cover"
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>
//           )}

//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10">
//             <div className="lg:col-span-2">
//               <div className="grid grid-cols-1">
//                 <div className="order-1 lg:order-2 mt-5 lg:mt-10 text-left">
//                   {/* goes to table "properties" as "heading" */}
//                   <input
//                     type="text"
//                     maxLength={100}
//                     value={heading}
//                     onChange={(e) => setHeading(e.target.value)}
//                     className="fontPD flex w-full text-left text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     style={{
//                       letterSpacing: "1px",
//                       wordSpacing: "2px",
//                       lineHeight: 1.3,
//                     }}
//                     placeholder="Heading"
//                   />
//                   <p className="text-xs text-left block mt-1">
//                     {heading.length.toString().padStart(2, "0")}/100
//                   </p>

//                   {/* goes to table "properties" as "content" */}
//                   <div className="my-5 lg:my-10">
//                     <textarea
//                       type="text"
//                       rows="3"
//                       maxLength={400}
//                       value={content}
//                       onChange={(e) => setContent(e.target.value)}
//                       className="flex w-full text-left border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       placeholder="Content..."
//                     />
//                     <span className="text-xs block mt-1">
//                       {content.length.toString().padStart(2, "0")}/400
//                     </span>
//                   </div>
//                 </div>
//                 {/* goes to table "properties" as "catchquote" */}

//                 <div className="mt-5 lg:mt-0 order-3">
//                   <input
//                     type="text"
//                     maxLength={100}
//                     value={catchyQuote}
//                     onChange={(e) => setCatchyQuote(e.target.value)}
//                     className="flex w-full md:text-xl text-left border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     placeholder="Catchy Quote"
//                   />
//                   <p className="text-xs text-left block mt-1">
//                     {catchyQuote.length.toString().padStart(2, "0")}/100
//                   </p>

//                   <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-5 justify-center">
//                     <div className="h-[1px] w-full bg-gray-300" />
//                     <img
//                       src="../assets/zorba_logo.webp"
//                       alt="Img"
//                       className="h-4 w-auto"
//                     />
//                     <div className="h-[1px] w-full bg-gray-300" />
//                   </div>
//                 </div>
//               </div>
//               {/* Carousel of Amenities Experience */}
//               <div className="mt-5 mb-10" ref={containerRef_amenities}>
//                 <div className="text-center mb-4">
//                   <h2 className="text-2xl font-semibold">Amenities</h2>
//                   <p className="text-gray-500 mt-1">
//                     {selectedAmenities.length} selected
//                   </p>
//                 </div>

//                 <input
//                   type="text"
//                   placeholder="Search amenities..."
//                   className="w-full mb-4 px-4 py-3 border rounded-lg focus:outline-none focus:ring-0 focus:border-[1.5px] focus:border-black"
//                   value={searchTerm}
//                   onFocus={() => setIsOpen_amenities(true)}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />

//                 {isOpen_amenities && (
//                   <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 overflow-y-auto max-h-96">
//                     {filteredAmenities.map((amenity, index) => {
//                       const isSelected = selectedAmenities.includes(amenity.id);

//                       return (
//                         <div
//                           key={index}
//                           onClick={() => toggleAmenity(amenity.id)}
//                           className={`relative cursor-pointer rounded-xl border px-3 py-5 transition-all duration-200
//                         ${
//                           isSelected
//                             ? "border-black shadow-md"
//                             : "border-gray-200 hover:border-gray-400"
//                         }`}
//                         >
//                           {/* Tick */}
//                           {isSelected && (
//                             <div className="absolute top-3 right-3 bg-green-800 text-white rounded-full p-1">
//                               <Check size={16} />
//                             </div>
//                           )}

//                           {/* Icon */}
//                           <img
//                             src="https://www.freeiconspng.com/thumbs/wifi-icon/3d-black-wifi-icon-9.png"
//                             alt={amenity.name}
//                             className="w-auto h-20 mb-3 object-contain"
//                           />

//                           {/* Text */}
//                           <p className="text-base font-medium">
//                             {amenity.name}
//                           </p>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//               {/* Wrapping Carousel for all 5 image categories */}
//               {/* Bedroom Carousel — sourced from the banner images assigned to
//                   "Bedroom 1", "Bedroom 2", ... "Bedroom N" categories above. */}
//               <div className="mt-8 mb-5 border border-gray-200 p-4 rounded-xl shadow-sm bg-gray-50 -mx-3 md:mx-0">
//                 {/*
//   Bedroom structure:
//   - One row per bedroom in `allPropertyBedrooms`
//   • propertyid
//   • position = roomIndex + 1

//   - One row per image in `allPropertyBedroomImages`, sourced from the banner
//     images tagged with category "Bedroom {position}"
//   • bedroomID (FK -> allPropertyBedrooms.id)
//   • imageurl
//   • position = imgIndex + 1
//   */}
//                 <Carousel
//                   key={`bedroom-outer-carousel-${parseInt(bookingRooms) || 1}`}
//                   responsive={responsive_OuterCarousel}
//                   autoPlay={false}
//                   infinite={true}
//                   showDots={true}
//                   keyBoardControl={true}
//                   arrows={false}
//                 >
//                   {Array.from({ length: parseInt(bookingRooms) || 1 }).map(
//                     (_, roomIndex) => {
//                       const images = getBedroomImages(roomIndex);
//                       return (
//                         <div key={roomIndex} className="px-4 pb-8">
//                           <h3 className="text-center font-bold text-lg mb-4">
//                             Bedroom {roomIndex + 1} Images{" "}
//                             <span className="text-sm font-normal text-gray-400">
//                               ({images.length})
//                             </span>
//                           </h3>

//                           {images.length === 0 ? (
//                             <div className="flex flex-col items-center justify-center w-full aspect-[4/3] max-h-[350px] bg-white border-dashed border-2 border-gray-300 rounded-lg text-center px-4">
//                               <p className="text-sm text-gray-400">
//                                 No images assigned yet. Add images in the banner
//                                 above and set their category to "Bedroom{" "}
//                                 {roomIndex + 1}".
//                               </p>
//                             </div>
//                           ) : (
//                             <Carousel
//                               key={`bedroom-inner-carousel-${roomIndex}-${images.length}`}
//                               responsive={responsive_ImageCarouselOne}
//                               autoPlay={false}
//                               autoPlaySpeed={3000}
//                               infinite
//                               keyBoardControl
//                               showDots={showDots}
//                               customLeftArrow={<CustomLeftArrowPlain />}
//                               customRightArrow={<CustomRightArrowPlain />}
//                             >
//                               {images.map((img, imgIndex) => (
//                                 <div key={img.bannerIndex} className="mx-3">
//                                   <div className="flex flex-col items-center justify-between w-full aspect-[4/3] max-h-[350px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                                     <img
//                                       src={img.url}
//                                       alt={`Bedroom ${roomIndex + 1} - ${imgIndex + 1}`}
//                                       className="w-full h-full object-cover"
//                                     />
//                                     <div
//                                       onClick={() =>
//                                         handleBannerImageDelete(img.bannerIndex)
//                                       }
//                                       title="Remove this image from the banner"
//                                       className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
//                                     >
//                                       <MdDelete size={18} />
//                                     </div>
//                                     <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                                       {imgIndex + 1}
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))}
//                             </Carousel>
//                           )}
//                         </div>
//                       );
//                     },
//                   )}
//                 </Carousel>
//               </div>
//               {/* Map */}
//               <div className="mt-12">
//                 <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
//                   <div>
//                     {/* goes to table "propertyImages" as maptitle */}
//                     <textarea
//                       type="text"
//                       maxLength={50}
//                       value={maptitle}
//                       onChange={(e) => setmaptitle(e.target.value)}
//                       rows={2}
//                       className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       style={{
//                         letterSpacing: "1px",
//                         wordSpacing: "2px",
//                         lineHeight: 1.3,
//                       }}
//                       placeholder="Map Title"
//                     />
//                     <p className="text-xs block">
//                       {maptitle.length.toString().padStart(2, "0")}/50
//                     </p>
//                   </div>

//                   <div>
//                     {/* goes to table "propertyImages" as mapcontent */}
//                     <textarea
//                       type="text"
//                       maxLength={150}
//                       value={mapcontent}
//                       onChange={(e) => setmapcontent(e.target.value)}
//                       rows={4}
//                       className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       placeholder="Map Content..."
//                     />
//                     <p className="text-xs block">
//                       {mapcontent.length.toString().padStart(2, "0")}/150
//                     </p>
//                   </div>
//                 </div>
//                 {/* goes to table "properties" as maplang  */}
//                 <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Map Latitude (maplang)
//                     </label>
//                     <input
//                       type="number"
//                       step="0.00000001"
//                       name="maplang"
//                       value={maplang}
//                       onChange={(e) => setmaplang(e.target.value)}
//                       placeholder="Enter Latitude"
//                       className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     />
//                   </div>
//                   {/* goes to table "properties" as  maplong */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Map Longitude (maplong)
//                     </label>
//                     <input
//                       type="number"
//                       step="0.00000001"
//                       name="maplong"
//                       value={maplong}
//                       onChange={(e) => setmaplong(e.target.value)}
//                       placeholder="Enter Longitude"
//                       className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* Side StickyCard */}
//             <div className="lg:col-span-1 relative">
//               <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 pb-4 sticky top-10">
//                 <div className="mb-4">
//                   <div className="flex items-center text-4xl font-bold text-[#A23321]">
//                     ₹ {/* goes to table properties as currentprice */}
//                     <input
//                       type="text"
//                       value={bookingPrice}
//                       placeholder="Enter Current Price"
//                       onChange={(e) => setBookingPrice(e.target.value)}
//                       className="text-xl w-full bg-transparent border-b border-gray-300 focus:border-black focus:ring-0 px-1 py-0"
//                     />
//                   </div>
//                   <input
//                     type="text"
//                     value={bookingPriceDetails}
//                     onChange={(e) => setBookingPriceDetails(e.target.value)}
//                     className="text-base text-gray-400 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 px-1 py-0 mt-1"
//                   />
//                 </div>

//                 <div className="grid grid-cols-2 gap-4 mb-4">
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       Check-in ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
//                       <input
//                         type="date"
//                         value={bookingcheckinDate}
//                         onChange={(e) => setBookingcheckinDate(e.target.value)}
//                         className="text-base text-gray-800 font-medium w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0"
//                       />
//                       <input
//                         type="time"
//                         value={bookingcheckintime}
//                         onChange={(e) => setBookingcheckintime(e.target.value)}
//                         className="text-sm text-gray-500 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0 mt-1"
//                       />
//                     </div>
//                   </div>
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       Check-out ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
//                       <input
//                         type="date"
//                         value={bookingcheckoutDate}
//                         onChange={(e) => setBookingcheckoutDate(e.target.value)}
//                         className="text-base text-gray-800 font-medium w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0"
//                       />
//                       <input
//                         type="time"
//                         value={bookingcheckouttime}
//                         onChange={(e) => setBookingcheckouttime(e.target.value)}
//                         className="text-sm text-gray-500 w-full bg-transparent border-b border-gray-200 focus:border-black focus:ring-0 p-0 mt-1"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="grid grid-cols-2 gap-4 mb-6">
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       Guests ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-2">
//                       <div className="flex items-center border-b border-gray-200 focus-within:border-black">
//                         {/* goes to table properties as maxadult */}
//                         <input
//                           type="number"
//                           value={bookingAdults}
//                           onChange={(e) => setBookingAdults(e.target.value)}
//                           className="text-base text-gray-800 font-medium w-8 bg-transparent border-none focus:ring-0 p-0"
//                         />
//                         <span className="text-base text-gray-800 font-medium ml-1">
//                           Adults,
//                         </span>
//                       </div>
//                       <div className="flex items-center border-b border-gray-200 mt-1 focus-within:border-black">
//                         {/* goes to table properties as maxchild */}
//                         <input
//                           type="number"
//                           value={bookingChildren}
//                           onChange={(e) => setBookingChildren(e.target.value)}
//                           className="text-base text-gray-800 font-medium w-8 bg-transparent border-none focus:ring-0 p-0"
//                         />
//                         <span className="text-base text-gray-800 font-medium ml-1">
//                           Children
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                   <div>
//                     <label className="text-sm text-gray-500 font-medium block mb-1">
//                       No. of Rooms ▾
//                     </label>
//                     <div className="bg-gray-50 border border-gray-200 rounded-md p-3 text-center">
//                       <div className="flex items-center justify-center border-b border-gray-200 focus-within:border-black">
//                         {/* goes to table properties as maxbed
//                             Synced with "Max Bedroom" in the Required Data
//                             section above — same `bookingRooms` state. */}
//                         <input
//                           type="number"
//                           value={bookingRooms}
//                           onChange={(e) => setBookingRooms(e.target.value)}
//                           className="text-base text-gray-800 font-medium w-12 text-right bg-transparent border-none focus:ring-0 p-0"
//                         />
//                         <span className="text-base text-gray-800 font-medium ml-2">
//                           Rooms
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <hr className="border-gray-200 mb-4" />

//                 <div className="flex justify-between items-center mb-0">
//                   <p className="text-2xl font-bold text-gray-800">Total</p>
//                   <div className="text-right">
//                     <div className="flex items-center justify-end text-2xl font-bold text-[#A23321]">
//                       ₹{" "}
//                       <input
//                         type="text"
//                         value={bookingTotal}
//                         placeholder="Final Price"
//                         onChange={(e) => setBookingTotal(e.target.value)}
//                         className="w-32 text-xl text-right bg-transparent border-b border-gray-300 focus:border-black focus:ring-0 px-1 py-0"
//                       />
//                     </div>
//                     <p className="text-sm text-gray-400 mt-1">(Incl. taxes)</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* Break */}
//           <div className="flex gap-3 items-center mx-5 md:mx-[5%] my-8 md:my-14 justify-center">
//             <div className="h-[1px] w-full bg-gray-300" />
//             <img
//               src="../assets/zorba_logo.webp"
//               alt="Img"
//               className="h-4 w-auto"
//             />
//             <div className="h-[1px] w-full bg-gray-300" />
//           </div>
//           {/* Break over  */}

//           {/* Tailored Experience */}
//           <div className="">
//             <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
//               <div>
//                 {/* goes to table "experiences" as "expnamemain" */}
//                 <input
//                   type="text"
//                   placeholder="Experience"
//                   maxLength={50}
//                   value={tailoredExperience}
//                   onChange={(e) => setTailoredExperience(e.target.value)}
//                   className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   style={{
//                     letterSpacing: "1px",
//                     wordSpacing: "2px",
//                     lineHeight: 1.3,
//                   }}
//                 />
//                 <p className="text-xs block mt-1">
//                   {tailoredExperience.length.toString().padStart(2, "0")}/50
//                 </p>

//                 {/* goes to table "experiences" as "expcontentmain" */}
//               </div>

//               <textarea
//                 type="text"
//                 rows={3}
//                 placeholder="Content..."
//                 value={tailoredExperienceContent}
//                 onChange={(e) => setTailoredExperienceContent(e.target.value)}
//                 maxLength={150}
//                 className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//               />
//               <p className="text-xs block">
//                 {tailoredExperienceContent.length.toString().padStart(2, "0")}
//                 /150
//               </p>
//             </div>

//             {/* Carousel of Tailored Experience */}
//             <div className="mt-5 -mx-3">
//               {/* goes to table "experiences" as "imagegrid1	, imagegrid2, imagegrid3 and imagegrid4" */}
//               <Carousel
//                 ref={carouselRef}
//                 responsive={responsive_TailoredExpCarousel}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
//                 customRightArrow={<CustomRightArrowTailoredExpCarousel />}
//                 beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
//               >
//                 {[...Array(MAX_CARDS_Exp)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="relative w-full h-[350px] bg-white border-2 border-dashed border-gray-400 overflow-hidden">
//                       {tailoredExpData[index]?.img ? (
//                         <>
//                           <img
//                             src={tailoredExpData[index].img}
//                             alt="Img"
//                             className="w-full h-full object-cover"
//                           />
//                           <div
//                             onClick={() => {
//                               const newData = [...tailoredExpData];
//                               newData[index] = {
//                                 ...newData[index],
//                                 img: null,
//                                 file: null,
//                               };
//                               setTailoredExpData(newData);
//                             }}
//                             className="absolute top-1 right-1 bg-white/60 rounded-full p-1 cursor-pointer hover:bg-white text-gray-600 hover:text-red-600 transition"
//                           >
//                             <MdDelete size={18} />
//                           </div>

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/webp"
//                               onChange={(e) => {
//                                 const file = e.target.files[0];
//                                 if (file) {
//                                   const newData = [...tailoredExpData];
//                                   newData[index].img =
//                                     URL.createObjectURL(file); // preview
//                                   newData[index].file = file; // actual File for backend
//                                   setTailoredExpData(newData);
//                                 }
//                               }}
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/webp"
//                             onChange={(e) => {
//                               const file = e.target.files[0];
//                               if (file) {
//                                 const newData = [...tailoredExpData];
//                                 newData[index].img = URL.createObjectURL(file);
//                                 newData[index].file = file;
//                                 setTailoredExpData(newData);
//                               }
//                             }}
//                             className="hidden"
//                           />
//                         </label>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>

//               <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
//                 <FaChevronLeft
//                   onClick={handlePrevSlide}
//                   className="cursor-pointer"
//                 />
//                 Showing {(activeCardIndex % TailoredExpCarousel.length) + 1} /
//                 {TailoredExpCarousel.length}
//                 <FaChevronRight
//                   onClick={handleNextSlide}
//                   className="cursor-pointer"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="mt-14 mb-5">
//           {submitError && (
//             <p className="text-red-600 text-sm mt-4">{submitError}</p>
//           )}

//           <div className="grid grid-cols-2 gap-3 mt-10 w-72 mx-auto">
//             <button
//               type="button"
//               onClick={() => navigate("/Properties")}
//               className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//             >
//               Cancel
//             </button>

//             <button
//               type="button"
//               onClick={handleSubmit}
//               disabled={isSubmitting}
//               className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {isSubmitting ? "Saving..." : "Save"}
//             </button>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default TestEditPropertyDetailElementor;
